// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen-reader-hidden {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
#site-header{
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13,110,253;
  --bs-secondary-rgb: 108,117,125;
  --bs-success-rgb: 25,135,84;
  --bs-info-rgb: 13,202,240;
  --bs-warning-rgb: 255,193,7;
  --bs-danger-rgb: 220,53,69;
  --bs-light-rgb: 248,249,250;
  --bs-dark-rgb: 33,37,41;
  --bs-white-rgb: 255,255,255;
  --bs-black-rgb: 0,0,0;
  --bs-body-color-rgb: 33,37,41;
  --bs-body-bg-rgb: 255,255,255;
  --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0,0,0,.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  text-align: var(--bs-body-text-align);
  color: #414141;
  font-family: CVS-reg,sans-serif;
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59,130,246,.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 3px solid #ddd;
  position: sticky;

  top: 0;
  width: 100%;
  z-index: 15;
}

#site-header > .upper-nav{
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13,110,253;
  --bs-secondary-rgb: 108,117,125;
  --bs-success-rgb: 25,135,84;
  --bs-info-rgb: 13,202,240;
  --bs-warning-rgb: 255,193,7;
  --bs-danger-rgb: 220,53,69;
  --bs-light-rgb: 248,249,250;
  --bs-dark-rgb: 33,37,41;
  --bs-white-rgb: 255,255,255;
  --bs-black-rgb: 0,0,0;
  --bs-body-color-rgb: 33,37,41;
  --bs-body-bg-rgb: 255,255,255;
  --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0,0,0,.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  text-align: var(--bs-body-text-align);
  color: #414141;
  font-family: CVS-reg,sans-serif;
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59,130,246,.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  box-sizing: border-box;
}
button.hamburger.hamburger--squeeze
.hamburger-inner{
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13,110,253;
  --bs-secondary-rgb: 108,117,125;
  --bs-success-rgb: 25,135,84;
  --bs-info-rgb: 13,202,240;
  --bs-warning-rgb: 255,193,7;
  --bs-danger-rgb: 220,53,69;
  --bs-light-rgb: 248,249,250;
  --bs-dark-rgb: 33,37,41;
  --bs-white-rgb: 255,255,255;
  --bs-black-rgb: 0,0,0;
  --bs-body-color-rgb: 33,37,41;
  --bs-body-bg-rgb: 255,255,255;
  --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0,0,0,.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  color: inherit;
  font: inherit;
  text-transform: none;
  cursor: pointer;
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59,130,246,.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  box-sizing: border-box;
  display: block;
  margin-top: -2px;
  top: 50%;
  background-color: #000;
  border-radius: 4px;
  height: 4px;
  position: absolute;
  transition-property: transform;
  width: 40px;
  transition-duration: 75ms;
  transition-timing-function: cubic-bezier(.55,.055,.675,.19);
}

button.hamburger.hamburger--squeeze.is-active 
.hamburger-inner
{
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13,110,253;
  --bs-secondary-rgb: 108,117,125;
  --bs-success-rgb: 25,135,84;
  --bs-info-rgb: 13,202,240;
  --bs-warning-rgb: 255,193,7;
  --bs-danger-rgb: 220,53,69;
  --bs-light-rgb: 248,249,250;
  --bs-dark-rgb: 33,37,41;
  --bs-white-rgb: 255,255,255;
  --bs-black-rgb: 0,0,0;
  --bs-body-color-rgb: 33,37,41;
  --bs-body-bg-rgb: 255,255,255;
  --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0,0,0,.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  color: inherit;
  font: inherit;
  text-transform: none;
  cursor: pointer;
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59,130,246,.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  box-sizing: border-box;
  display: block;
  margin-top: -2px;
  top: 50%;
  border-radius: 4px;
  height: 4px;
  position: absolute;
  transition-property: transform;
  width: 40px;
  transition-duration: 75ms;
  background-color: #000;
  transform: rotate(45deg);
  transition-delay: .12s;
  transition-timing-function: cubic-bezier(.215,.61,.355,1);
}



#mySidenav.nav-wrapper.open{
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13,110,253;
  --bs-secondary-rgb: 108,117,125;
  --bs-success-rgb: 25,135,84;
  --bs-info-rgb: 13,202,240;
  --bs-warning-rgb: 255,193,7;
  --bs-danger-rgb: 220,53,69;
  --bs-light-rgb: 248,249,250;
  --bs-dark-rgb: 33,37,41;
  --bs-white-rgb: 255,255,255;
  --bs-black-rgb: 0,0,0;
  --bs-body-color-rgb: 33,37,41;
  --bs-body-bg-rgb: 255,255,255;
  --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0,0,0,.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  text-align: var(--bs-body-text-align);
  color: #414141;
  font-family: CVS-reg,sans-serif;
  --tw-bg-opacity: 1!important;
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59,130,246,.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  box-sizing: border-box;
  background: #602978;
  height: 100%;
  overflow-x: hidden;
  position: fixed;
  right: 0;
  top: 57px;
  transition: .5s;
  z-index: 11;
  width: 100%;
}
#mySidenav.nav-wrapper{
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13,110,253;
  --bs-secondary-rgb: 108,117,125;
  --bs-success-rgb: 25,135,84;
  --bs-info-rgb: 13,202,240;
  --bs-warning-rgb: 255,193,7;
  --bs-danger-rgb: 220,53,69;
  --bs-light-rgb: 248,249,250;
  --bs-dark-rgb: 33,37,41;
  --bs-white-rgb: 255,255,255;
  --bs-black-rgb: 0,0,0;
  --bs-body-color-rgb: 33,37,41;
  --bs-body-bg-rgb: 255,255,255;
  --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0,0,0,.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  text-align: var(--bs-body-text-align);
  color: #414141;
  font-family: CVS-reg,sans-serif;
  --tw-bg-opacity: 1!important;
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59,130,246,.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
  box-sizing: border-box;
  background: #602978;
  height: 100%;
  overflow-x: hidden;
  position: fixed;
  right: 0;
  top: 57px;
  transition: .5s;
  width: 0;
  z-index: 11;
}

#lightBulbDiv {
  margin-top: 1%;
  background: #fff;
  padding: 15px;
  border: 0.5px dashed gray;
}

#lightBulbLeftBlock {
  width: 5%;
  float: left;
}

#lightBulbRightBlock {
  width: 92%;
  float: right;
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
  background-color: #7d3f98;
  border: 0 none;
}

#sessionTimeoutModalPhr {
  color: #fff;
  font-size: 24px !important;
  font-family: Domaine Display !important;
  font-weight: 700;
}

.modal-header .close {
  margin-top: 4px;
}

.acc-modal-header .close {
  margin-top: -42px;
}

@media (min-width: 992px) {
  .acc-modal-header .close {
    margin-top: -30px;
  }
}

.usefulInfo-block {
  padding: 5px;
}

.saveAndContinue {
  width: 205px !important;
}

.border-bottom {
  border: 5px solid #eee !important;
}

.espanolpage {
  background-color: #fff !important;
  border: 1px solid #ccc;
  box-shadow: 0 2px 2px -1px #ccc;
}

.coverageBenefits_bg {
  background-color: #eee !important;
  padding-top: 10px;
}

.navbar-default .navbar-nav > li > a:active,
.navbar-default .navbar-nav > li > a:focus {
  text-decoration: underline !important;
}

.nav-mobile-list .menu-button {
  display: none !important;
}

.newDiscountThumb {
  border-radius: 0 !important;
}

.newDiscountThumb .cardimagecaption {
  padding-bottom: 12px;
}

.newDiscountThumb .cardimagecaptionJoint {
  opacity: 0.8;
  padding-bottom: 12px;
}

.padLeftClear {
  padding-left: 15px;
}

.padRightClear {
  padding-right: 15px;
}

.linkActiveUnderline {
  text-decoration: underline !important;
}

.linkDeactiveUnderline {
  text-decoration: none !important;
}

.nav-tabs {
  padding: 10px;
  position: absolute;
  z-index: 10;
  display: none;
}

@media (min-width: 992px) {
  .nav-tabs {
    position: relative;
    display: block !important;
  }

  .global-overlay {
    display: none;
  }
}

body,
html {
  font-family: Open Sans !important;
  font-weight: 400;
  color: #414141;
}

body {
  background: #fff;
  overflow-x: hidden;
  font-size: 16px;
  padding-right: 0 !important;
  -ms-overflow-style: scrollbar;
}

li,
ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.claimsNarrowDown .padTB16 {
  background: #7d3f98;
  padding: 12px 0 !important;
}

a,
a:visited {
  color: #7d3f98;
}

a,
a:focus {
  text-decoration: none;
}

a:focus {
  color: #076f86;
}

a:active {
  color: #d20962 !important;
  text-decoration: none;
}

a:focus,
a:hover {
  color: #7d3f98;
  text-decoration: underline;
}

section a {
  font-weight: 400;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: Open Sans !important;
}

h1,
h2,
h3,
h4,
h5 {
  font-weight: 400 !important;
  margin: 0 !important;
}

h1 {
  font-size: 1.5em;
}

h2 {
  font-size: 1.06em;
}

h3 {
  font-size: 0.875em;
}

small {
  font-size: 0.68em;
}

label,
p,
span {
  font-size: 16px;
  color: #414141;
  font-weight: 400;
}

img {
  text-indent: -9999px;
  max-width: 100% !important;
}

section {
  background: #eee;
}

input[type="checkbox"],
input[type="radio"] {
  opacity: 0;
}

input[type="radio"] {
  vertical-align: top;
}

address {
  display: inline-block;
}

legend {
  margin-bottom: 12px;
  border-bottom: 0 none;
}

textarea {
  overflow: auto;
  background-color: #eee;
  width: 100%;
  height: 150px;
}

sup {
  color: #7d3798;
  font-size: 14px !important;
  padding: 0;
  margin: 0;
  position: relative;
  top: -0.5em !important;
}

ul.bulletType_disc,
ul.bulletType_disc li {
  list-style: disc outside none;
}

ul.bulletType_check li:before {
  content: "\\2713\\0020";
}

ul.orientation_vertical {
  padding-left: 40px;
}

ul.bulletType_decimal,
ul.bulletType_decimal li {
  list-style: decimal outside none;
}

ul.menu-list li a {
  margin-left: 10px;
}

.aet-sponser-logo {
  display: inline !important;
}

.menu-overlay {
  background: #000;
  position: absolute;
  top: 115px;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 0.5;
  z-index: 1000;
}

.menu-list {
  position: absolute;
  width: 360px;
  background: #eee none repeat scroll 0 0;
  z-index: 100000;
  border: 1px solid #ccc;
  top: 0;
}

ul.menu-list li a span {
  font-size: 18px;
}

ul.menu-list li {
  margin: 0 4px 4px;
  padding: 10px !important;
  background: #fff none repeat scroll 0 0;
  position: relative;
  width: 98%;
}

ul.menu-list li.home-mobile-list,
ul.menu-list li.home-mobile-list ul li {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
}

ul.menu-list li.home-mobile-list ul li {
  padding: 8px 5px !important;
}

.menu-list li.inactive {
  padding: 9px 10px !important;
  background: #eee none repeat scroll 0 0;
  margin: 0;
}

.menu-list li a img.left-img {
  width: 80%;
}

ul.menu-list li.home-mobile-list ul li .badge {
  font-size: 14px;
  padding: 2px 10px;
  margin-top: -12px;
}

.menu-list li a.blueActive,
.menu-list li a.canbActive,
.menu-list li a.greenActive,
.menu-list li a.purpleActive,
.menu-list li a.tealActive {
  box-shadow: 0 0 5px 0 #ccc;
  font-weight: 700;
}

.menu-list-txt {
  margin: 8px 0 0 10px;
}

.nested-list a {
  display: none;
  margin-left: 30px;
  padding: 10px !important;
}

.purpuleShade {
  background-color: transparent;
}

.second-navigation {
  background: #fff;
  border-bottom: 1px solid #ccc;
  position: relative;
}

.second-navigation a,
.second-navigation p {
  color: #596368;
  display: block;
  padding: 15px 25px;
  border-bottom: 3px solid transparent;
  border-right: 1px solid #ccc;
  float: none;
  font-size: 20px;
  background-color: #e0e0e0;
  border: 1px solid #f5f5f5 !important;
  margin: 1%;
}

.second-navigation a.canbLevel {
  font-weight: 700;
  color: #2f3338;
}

.second-navigation a.canbLevel {
  background-color: #7d3f98;
  border: 3px solid #fff;
  border-bottom: none !important;
  color: #fff !important;
  position: relative;
}

.second-navigation a.canbLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #7d3f98;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.second-navigation a.messageLevel {
  font-weight: 700;
  color: #2f3338;
}

.second-navigation a.messageLevel {
  background-color: #526f83;
  border: 3px solid #fff;
  border-bottom: none !important;
  color: #fff !important;
  position: relative;
}

.second-navigation a.messageLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #526f83;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.second-navigation a.blueLevel {
  background-color: #0d8ba7;
  border: 3px solid #fff;
  border-bottom: none !important;
  color: #fff !important;
  position: relative;
}

.second-navigation a.blueLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #0d8ba7;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.second-navigation a.purpleLevel {
  background-color: #7d3f98;
  border: 3px solid #fff;
  border-bottom: none !important;
  color: #fff !important;
  position: relative;
}

.second-navigation a.purpleLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #7d3f98;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.second-navigation a.greenLevel {
  background-color: #4e7d2a;
  border: 3px solid #fff;
  border-bottom: none !important;
  color: #fff !important;
  position: relative;
}

.second-navigation a.greenLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #4e7d2a;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.second-navigation a.tealLevel {
  background-color: #00a783;
  border: 3px solid #fff;
  color: #fff !important;
  position: relative;
}

.second-navigation a.tealLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #00a783;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.second-navigation p.oliveGreenLevel {
  background-color: #4e7d2a;
  border: 3px solid #fff;
  border-bottom: none !important;
  color: #fff !important;
  position: relative;
}

.second-navigation p.oliveGreenLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #4e7d2a;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.second-navigation p.teal-greenLevel {
  background-color: #00a783;
  border: 3px solid #fff;
  border-bottom: none !important;
  color: #fff !important;
  position: relative;
}

.second-navigation p.teal-greenLevel:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #00a783;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.left-scrollarrow,
.right-scrollarrow {
  background-image: url(https://member.aetna.com/secure/member/images/claimsArrow_left.png);
  background-repeat: no-repeat;
  background-position: 50%;
  width: 14px;
  height: 40px;
  background-color: #fff;
  opacity: 0.9;
  display: inline-block;
  padding: 25px;
  position: absolute;
  top: -58px;
  visibility: hidden;
}

.scroll-arrowsLR {
  position: relative;
  display: none;
}

.right-scrollarrow {
  background-image: url(https://member.aetna.com/secure/member/images/claimsArrow.png);
  right: 0;
}

.sec-level-nav {
  padding: 10px 20px;
  display: inline-block;
  border-left: 0 none;
  border-right: 1px solid #ccc;
}

.sec-level-nav:first-child {
  border-left: 1px solid #ccc;
}

.borderLeftGrey {
  border-left: 1px solid #ccc !important;
}

.bH_pleat_bg_color {
  background-color: #7d3f98;
}

.menu-txt {
  font-size: 20px;
  float: right;
  color: #076f86;
  margin: 5px 0;
  text-align: right;
  width: 25% !important;
}

.menu-txt:focus {
  outline: none !important;
  box-shadow: 0 0 10px #719ece;
}

.line-seperator {
  background: url(https://member.aetna.com/secure/member/images/header-sep.png) no-repeat 0 0;
  height: 30px;
  width: 2px;
  position: absolute;
  left: -25px;
  top: 12px;
}

.close-menu {
  background: url(https://member.aetna.com/secure/member/images/close.png) no-repeat 0 0;
  display: inline-block;
  height: 34px;
  width: 34px;
  position: absolute;
  left: 10px;
  bottom: 10px;
}

.logout-menu {
  background: url(https://member.aetna.com/secure/member/images/homeicons/logout_icon_mobile_transparent.png)
    no-repeat 0 0;
  display: inline-block;
  height: 46px;
  width: 46px !important;
  position: absolute !important;
  right: 10px;
  top: 5px;
  display: none;
}

.home-down-arrow,
.home-up-arrow {
  background: url(https://member.aetna.com/secure/member/images/homeicons/home-list-down.png) no-repeat 0 0;
  display: none;
  height: 9px;
  width: 15px;
}

.home-down-arrow.home-up-arrow {
  background: url(https://member.aetna.com/secure/member/images/homeicons/home-list-up.png) no-repeat 0 0;
  display: none;
}

.menu-mobile-icon {
  width: 78%;
  display: none !important;
}

a.blueActive,
a.canbActive,
a.greenActive,
a.purpleActive,
a.tealActive,
ul li.blueActive a span,
ul li.canbActive a span,
ul li.greenActive a span,
ul li.purpleActive a span,
ul li.tealActive a span {
  color: #2f3338;
}

.blueActive,
.canbActive,
.greenActive,
.purpleActive,
.tealActive {
  border-color: #d20962;
  border-style: solid;
  border-width: 0 0 0 5px;
}

.blueActive {
  border-color: #0d8ba7;
}

.purpleActive {
  border-color: #7d3f98;
}

.greenActive {
  border-color: #00a783;
}

h1.greenActive {
  border-color: transparent;
}

.tealActive {
  border-color: #5e9732;
}

section {
  background-color: #fff;
}

[role="button"] {
  display: block;
}

button[disabled],
html input[disabled] {
  cursor: not-allowed;
  background: #b18cc1;
  color: #414141;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
}

.aet-content-fluid {
  max-width: 1141px;
  margin: 0 auto;
  padding-left: 0;
  padding-right: 0;
}

.aet-wrapper {
  position: relative;
}

.aet-template {
  margin-bottom: 0;
}

.aet-main-container {
  background-color: #fff;
}

.aet-nav-header {
  padding-bottom: 2px;
}

.panel-title a:hover {
  text-decoration: none;
}

.container-fluid {
  padding: 0;
}

.container1 {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.noborder {
  border: 0 !important;
}

.topMrgn30 {
  margin-top: 30px;
}

.mrgnR15 {
  margin-right: 15px;
}

.image-circle {
  border-radius: 50%;
}

.rightborder {
  border-right: 1px solid #ccc !important;
}

.white-section {
  background-color: #fff !important;
}

.top-mrgn10 {
  margin-top: 10px;
}

.badge {
  text-align: center;
  word-break: break-word;
  vertical-align: middle;
  white-space: normal;
  padding: 3px 10px;
  margin-top: -20px;
  margin-left: 5px;
  background: #b18cc0;
  border-radius: 6px;
}

.block {
  display: block;
}

.top-border {
  border-top: 1px solid #ccc;
}

.separator {
  color: #d0d1d3;
}

.mobile,
.mobile-view .desktop,
.tablet,
.tablet-view .desktop {
  display: none;
}

.disp-mob,
.mobile-view .mobile,
.tablet-view .tablet {
  display: block;
}

@media (max-width: 992px) {
  .mobilehide {
    display: none !important;
  }
}

.curser {
  cursor: pointer;
}

.fsize85P {
  font-size: 82%;
}

.fsize120p {
  font-size: 120%;
}

.wd100P {
  width: 100%;
}

.pointer {
  cursor: pointer;
}

.pad0,
.paddingZero {
  padding: 0;
}

.padR45 {
  padding-right: 45px;
}

.padR5 {
  padding-right: 5px;
}

.padL35 {
  padding-left: 35px;
}

.padL25 {
  padding-left: 25px;
}

.padL5 {
  padding-left: 5px;
}

span a div.padL5 {
  display: inline-block;
}

.marR10 {
  margin-right: 10px;
}

.marT15 {
  margin-top: 15px;
}

.marT10 {
  margin-top: 10px;
}

.pad10 {
  padding: 10px;
}

.padT5 {
  padding-top: 5px;
}

.padB5 {
  padding-bottom: 5px;
}

.fontstyle2 {
  font-size: 32px;
}

.fontstyle3 {
  font-size: 14px;
}

.fontsize1 {
  font-size: 16px !important;
}

.fontstyle16 {
  font-size: 16px;
}

.left-pad0 {
  padding-left: 0;
}

.right-pad0 {
  padding-right: 0;
}

.mar0 {
  margin: 0;
}

.padR0px {
  padding-right: 0;
}

.padBottom0 {
  padding-bottom: 0 !important;
}

.mrgnLeft {
  margin-left: 10%;
}

.mrgnLeft35 {
  margin-left: 35px;
}

.mrgnzero {
  margin: 0 !important;
}

.marT10px {
  margin-top: 10px;
}

.padB20 {
  padding-bottom: 20px;
}

.marR15 {
  margin-right: 15px;
}

.marL15 {
  margin-left: 15px;
}

.desktop-only {
  display: none;
}

.inline-block {
  display: inline-block !important;
}

.bold {
  font-weight: 700;
}

.disp-mob {
  display: none !important;
}

.disp-desktop {
  display: block !important;
}

@media (max-width: 991px) {
  .disp-desktop {
    display: none !important;
  }

  .mrgnLeft {
    margin-left: 0;
  }

  .bottom-border,
  .bottom-border-idcard {
    border-bottom: 1px solid #ccc !important;
  }
}

.mrgn20 {
  margin-top: 20px;
}

.padL110 {
  padding-left: 110px;
}

.disp-row {
  display: table-row;
}

.tableCell {
  display: table-cell;
}

.error {
  color: #a94442;
}

.err-txt {
  text-align: center;
  width: 100%;
  display: inline-block;
}

.positionRelative {
  position: relative;
}

.left-txt {
  text-align: left !important;
  margin: 0;
}

.anchor {
  color: #7d3f98;
}

.important {
  color: #ef4234;
}

.no-resize {
  resize: none;
}

.mandatory {
  color: #d20962;
}

.btn-submit button {
  border: none;
}

.white {
  background-color: #fff;
}

.redShade {
  background-color: #d20962;
}

.greenShade {
  background-color: #1d7564;
}

.purpuleShade {
  background-color: #7d3f98;
}

.lightBlueShade {
  background-color: #076f86;
}

.blueShade {
  background-color: #4b65ae;
}

.greyShade {
  background-color: #eee;
}

.depperGrey {
  background-color: #888;
}

.close,
.close:focus,
.close:hover {
  opacity: 1;
}

.underline {
  border-bottom: 1px solid #076f86;
}

.paddlr30 {
  padding-left: 30px;
  padding-right: 30px;
}

.pad20 {
  padding: 20px;
}

.topMrgn50 {
  margin-top: 50px;
}

.marBot60 {
  margin-bottom: 60px;
}

.uppercase {
  text-transform: uppercase;
}

.heads {
  color: #7d3f98;
  font-size: 1.25em;
}

.checkboxbg {
  margin-top: 1px;
}

.checkboxbg label {
  margin: 0;
}

.padR0 {
  padding-right: 0;
}

.marT8 {
  margin-top: 8px;
}

.marB0 {
  margin-bottom: 0;
}

.marB15 {
  margin-bottom: 15px;
}

.padT8 {
  padding-top: 8px;
}

.padL0 {
  padding-left: 0;
}

.padL0Imp {
  padding-left: 0 !important;
}

.padL15 {
  padding-left: 15px;
}

.normalFont {
  font-weight: 400;
}

.italics {
  font-style: italic;
}

.normalfont {
  font-weight: 400;
}

.font-20 {
  font-size: 20px;
}

.font14 {
  font-size: 14px;
}

.padL10 {
  padding-left: 10px;
}

.font18 {
  font-size: 18px;
}

.zeroMrgn {
  margin: 0 !important;
}

.white-bg {
  background: #fff;
}

.clear {
  clear: both;
}

.pad00 {
  padding: 0;
}

.hide-ac {
  font-size: 0;
}

.padT15 {
  padding-top: 15px;
}

.padB15 {
  padding-bottom: 15px;
}

.padB11 {
  padding-bottom: 11px;
}

.padR15 {
  padding-right: 15px;
}

.pad15 {
  padding: 15px;
}

.padR20 {
  padding: 20px;
}

.marTB10 {
  margin: 10px 0;
}

.marTB14 {
  margin: 14px 0;
}

.marB20 {
  margin-bottom: 20px;
}

ul li a span {
  color: #076f86;
  font-size: 15px;
}

.zeromrgn {
  margin: 0 !important;
}

.padzero {
  padding: 0;
}

.no-border {
  border: 0;
}

.bottom-border-idcard {
  border-bottom: 1px solid #ccc !important;
}

.no-border {
  border: 0 !important;
}

.break-word {
  word-break: break-word;
}

.pos-a {
  position: absolute;
}

.fixedScroller {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
  display: none;
}

.fixedScroller p.pad15 {
  padding: 5px 0;
}

.aet-cont-hdrtxt img {
  margin-right: 5px;
  margin-bottom: 5px;
}

.mar0auto {
  margin: 0 auto;
}

.opacity_layer {
  opacity: 0.9;
}

.fixedScroller.end .downPointer {
  display: none;
  opacity: 0;
}

.upPointer {
  display: none;
}

#aet-footer.mar0 {
  margin-bottom: 0;
}

.entireWarpper.shift .menu-toggle-btn .icon-bar {
  position: relative;
  transition: transform 0.5s;
  -moz-transition: transform 0.5s;
  -webkit-transition: transform 0.5s;
  -ms-transition: transform 0.5s;
  -o-transition: transform 0.5s;
}

.entireWarpper.shift .menu-toggle-btn .icon-bar:nth-child(2) {
  transform: rotate(35deg);
  -moz-transform: rotate(35deg);
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  -o-transform: rotate(35deg);
  top: 5px;
}

.entireWarpper.shift .menu-toggle-btn .icon-bar:nth-child(3) {
  display: none;
}

.entireWarpper.shift .menu-toggle-btn .icon-bar:nth-child(4) {
  transform: rotate(-35deg);
  -moz-transform: rotate(-35deg);
  -webkit-transform: rotate(-35deg);
  -ms-transform: rotate(-35deg);
  -o-transform: rotate(-35deg);
  top: -3px;
}

#skip-to-content {
  display: block !important;
}

#toFocus a {
  position: absolute;
  top: -100px;
  left: 0;
}

#skip-to-content a {
  padding: 6px 3px;
  position: absolute;
  top: -40px;
  left: 2px;
  color: #fff !important;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  border-bottom-right-radius: 8px;
  background: #526783;
  transition: top 1s ease-out, background 1s linear;
  z-index: 100;
}

#skip-to-content a:active,
#skip-to-content a:focus {
  position: absolute;
  left: 2px;
  top: 0;
  color: #fff;
  background: #526783;
  outline: 0;
  transition: top 0.1s ease-in, background 0.5s linear;
}



.aet-sponser-logo {
  display: inline;
}

.icon-block-purple img {
  background: #7d3f98;
  padding: 5px 6px;
  border-radius: 20px;
}

.sessionTimeout h1 {
  font-size: 24px;
}

.sessionTimeout .modal-body span,
.yourAlert .modal-body h2 {
  font-size: 20px;
}

.sessionTimeout .modal-footer button,
.yourAlert .modal-footer button {
  margin-right: 30px;
  margin-bottom: 20px;
}

.yourAlert .checkboxbg {
  margin-top: 25px;
}

#yourAlert {
  margin-top: 12%;
}

.menu-button .sr-only {
  font-size: 24px;
}

@media (min-width: 991px) {
  .margin-adjust-smc {
    margin-left: 50px !important;
  }
}

.attachmentAdjust {
  padding: 15px;
}

@media (max-width: 350px) {
  .mycol {
    width: 200px !important;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }

  .navbar-header {
    width: 100%;
  }

  .col-sm-3.pad0.col-xs-12.navbar-header {
    margin: 0;
  }

  .nav-mobile-list li {
    margin-right: 10px;
  }

  .nav-list-blk {
    color: #076f86;
    display: none !important;
    font-size: 14px;
  }

  .nav-mobile-list li {
    float: left;
    margin-right: 24px;
  }

  .nav-mobile-list li:last-child {
    margin-right: 0;
  }

  .nav-mobile-list {
    display: block;
    position: absolute;
    right: 10px;
    top: 20px;
  }

  .nav-mobile-username {
    display: block !important;
    position: absolute;
  }

  .navbar-collapse,
  .navbar-collapse.collapse {
    display: none !important;
  }

  .navbar {
    background: #fff;
    margin-bottom: 0;
    border: 0 none !important;
    padding: 20px 0;
  }
}

@media (min-width: 992px) {
  .psImageWidth {
    width: 25% !important;
  }

  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }
}

.aet-sponser-logo {
  display: inline;
}

@media screen and (min-width: 768px) {
  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }
}

@media (max-width: 991px) {
  .nav-mobile-list {
    display: block;
    position: absolute;
    right: 10px;
    top: 15px;
  }

  .nav-mobile-username {
    display: block !important;
    position: absolute;
    margin: 10px 0 0;
  }

  .nav-button {
    display: block;
    position: absolute;
    left: 0;
    top: 23px;
  }

  .aet-sponser-logo,
  .navbar-collapse,
  .navbar-collapse.collapse {
    display: none !important;
  }

  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }

  .aet-header .container {
    padding: 0;
    width: 100%;
  }

  .aet-sponser-logo {
    display: none !important;
  }

  .aet-logo img,
  .aet-sponser-logo,
  .navigator-logos a {
    width: 150px;
  }

  .navbar-default .navbar-nav > li > a img {
    display: none;
  }

  .show-icons .navbar-default .navbar-nav > li > a img {
    display: block;
    margin-left: 12px;
  }

  .show-icons .navbar-collapse {
    top: 0;
  }

  .navbar-collapse {
    right: 50px;
  }

  .navbar-default .navbar-nav > li > a.home-util,
  .navbar-default .navbar-nav > li > a:hover.home-util {
    margin-right: 0;
  }

  .navbar-nav > li {
    margin-right: 5px;
  }
}

@media screen and (max-width: 1200px) {
  .aet-sponser-logo {
    width: 150px;
  }

  .navbar-default .navbar-nav > li > a {
    padding: 0 5px;
  }

  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }
}

@media screen and (min-width: 1200px) {
  .navbar-default .navbar-nav > li > a {
    padding: 0 10px;
  }

  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }
}

@media (min-width: 992px) {
  .aet-sponser-logo {
    display: inline-block !important;
  }

  .navigator-logos a {
    width: 100px;
  }

  .nav-button {
    display: none;
  }

  .navbar-collapse,
  .navbar-collapse.collapse {
    display: block;
  }

  .menu-list {
    top: 0;
    right: auto;
    width: 250px;
  }
}

@media (min-width: 992px) {
  .aet-sponser-logo {
    display: inline-block !important;
  }

  .nav-button,
  .nav-mobile-list,
  .nav-mobile-username {
    display: none !important;
  }

  .navbar-collapse,
  .navbar-collapse.collapse {
    display: block !important;
  }

  .navbar-collapse {
    top: 8px;
  }

  .navbar-default .navbar-nav > li > a img {
    display: none;
  }

  .navbar-default .navbar-nav > li > a {
    padding: 0 6px;
  }

  .navbar-default .navbar-nav > li > a img {
    display: block;
    margin-left: 8px;
  }
}

@media (max-width: 991px) {
  .navbar-default .navbar-nav > li > a.home-util,
  .navbar-default .navbar-nav > li > a.home-util:hover {
    margin-top: 2px !important;
  }
}

@media (min-width: 992px) {
  .navbar-default .navbar-nav > li > a.home-util,
  .navbar-default .navbar-nav > li > a.home-util:hover {
    margin-top: -4px !important;
  }
}

@media (min-width: 1200px) {
  .navigator-logos .aet-logo .aet-sponser-logo,
  .navigator-logos .aet-sponser-logo {
    height: 40px;
    width: 240px;
  }

  .navbar-default .navbar-nav > li > a img {
    display: inline-block;
    margin-left: 0;
  }

  .navbar-default .navbar-nav > li > a {
    padding: 0 8px;
    border-right: 1px solid #076f86;
  }

  .navbar-collapse {
    top: 28px;
  }
}

@media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {
  .navbar-collapse {
    top: 5px !important;
  }
}

.select-box .dropdown-toggle.btn-default,
.select-box .dropdown-toggle.btn-default:focus {
  background-color: #fff;
}

.select-box .btn {
  width: 100%;
  text-align: left;
  height: 35px;
  border-radius: none;
  border-top: 0;
  border-left: 0;
  padding-left: 5px;
  padding-right: 5px;
  font-weight: 700;
}

.caret-image {
  position: absolute;
  width: 40px;
  border-top: 0;
  border-left: 0;
  font-weight: 700;
  background-image: url(https://member.aetna.com/secure/member/images/selectbox-select.png);
  background-repeat: no-repeat;
  background-position: 100% 0;
  background-color: #eee;
  height: 35px;
  border: 0 none;
  border-radius: 0;
  box-shadow: 0 1px #c5c5c5;
  top: 0;
  right: 0;
  margin: 0;
}

@media (max-width: 991px) {
  .second-navigation a.sec-level-nav {
    width: auto;
    border: 3px solid #fff;
  }

  .second-navigation1 .container1,
  .second-navigation .container {
    overflow-x: auto;
    white-space: nowrap;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 500px) {
  .second-navigation a.sec-level-nav {
    width: auto;
  }
}

@media (max-width: 768px) {
  .second-navigation,
  .second-navigation1 {
    width: 100%;
  }

  .second-navigation1 .container1,
  .second-navigation .container {
    margin: 0;
    width: auto;
  }

  .scroll-arrowsLR {
    display: block;
    margin-top: -6px;
  }
}

.select-box .option li:hover {
  background-color: #7d3f98;
  cursor: pointer;
}

.border-top-color-Sponsor-Links {
  border-top: 6px solid #586d7e;
  background-color: #eee;
  padding-top: 2%;
  margin-top: 2%;
}

.background-Third-Party-Links {
  background-color: #eee;
  padding-left: 2%;
  padding-bottom: 1%;
  margin-top: 20px;
}

.pslinks {
  font-weight: 700;
}

.progress-bar {
  background-color: #7d3f98;
}

.balanceBoxLinks {
  background: #7d3f98;
}

.sponsor_links a img {
  padding-left: 6px;
}

.wrap_sponsor_links {
  word-wrap: break-word !important;
}

.background-Third-Party-Links:first-child {
  box-shadow: none;
}

.close-menu:focus {
  outline: none !important;
}

.dentalInfogram,
.medicalInfogram {
  border: 1px solid #ccc;
  border-top: 3px solid #7d3f98;
  background: #fff;
}

.topHeadingBackGround {
  background: #7d3f98;
  margin-top: 30px;
}

.tableFormat .dataGridTableHeader th,
.tableFormat tbody tr td {
  padding: 15px;
}

.tableFormat tbody tr td {
  border-bottom: 1px solid #ccc;
}

.tableFormat tbody tr.evenRow,
.tableFormat tbody tr.oddRow {
  background-color: #fff;
}

table.tableFormat {
  border-collapse: separate;
  border: 1px solid #ccc;
  width: 100%;
}

.tableFormat .tableCaption {
  height: 0;
  padding: 0;
  color: #526f83;
}

.tableFormat .dataGridTableHeader {
  height: 65px;
  width: 100%;
  background-color: #7d3f98;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
}

.tableFormat .dataGridTableContant {
  background: #fff;
  margin-bottom: 15px;
}

.tableFormat .dataGridTableContant tr td:last {
  border-right: 1px solid #ccc;
}

.tableFormat thead .billhead a {
  width: 108px;
}

.tableFormat thead .reshead a {
  width: 165px;
}

.tableIncentive {
  margin-left: 20px;
}

.tableBenefits caption,
.tableIncentive caption {
  color: transparent;
  height: 0;
  padding: 0;
}

.tableIncentive .dataGridTableHeader th,
.tableIncentive tbody tr td {
  padding: 20px 190px 20px 20px;
}

.tableIncentive tbody tr {
  background: #eee;
  border-bottom: 10px solid #fff;
}

.tableBenefits thead th {
  width: 21%;
  padding-top: 15px;
  padding-bottom: 15px;
  background: #eee;
}

.tableBenefits {
  width: 100%;
}

@media (max-width: 1200px) {
  .tableIncentive .dataGridTableHeader th,
  .tableIncentive tbody tr td {
    padding: 20px 130px 20px 20px;
  }

  select {
    width: 170px;
  }
}

@media (max-width: 991px) {
  select {
    width: 97%;
  }

  .tableFormat.responsiveCustomTable td.deviceViewGridCol,
  .tableFormat.responsiveCustomTable th.deviceViewGridCol {
    display: none !important;
  }

  .tableIncentive .dataGridTableHeader th,
  .tableIncentive tbody tr td {
    padding: 20px 25px 20px 20px;
  }

  .tableFormat thead .billhead a,
  .tableFormat thead .reshead a {
    width: auto;
  }

  .new_claims_arrow {
    margin-top: 3px !important;
    margin-left: 5px !important;
  }

  .tableBenefits thead {
    display: none;
  }

  .tableBenefits td,
  .tableBenefits th {
    display: block !important;
  }

  .tableBenefits tr {
    border-top: 1px solid #ccc;
  }

  .panel.panel-default .tableBenefits div,
  .panel.panel-default .tableBenefits span {
    font-size: 16px;
  }

  .idCardWidth {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .padding-top-id {
    padding: 10px;
  }

  .noPull {
    float: right !important;
  }
}

@media (min-width: 767px) {
  #billAmtCol {
    width: 136px;
  }

  #providerCol {
    width: 180px;
  }

  #planPaidCol {
    width: 115px;
  }

  #youResponsbilityCol {
    width: 185px;
  }
}

@media (max-width: 767px) {
  #memberCol {
    font-size: 12px;
    width: 66px;
    padding-left: 0;
  }

  #providerCol {
    font-size: 12px;
    padding-left: 7px;
    width: 91px;
  }

  #memberData {
    padding-left: 0;
  }

  #providerData {
    padding-left: 7px;
  }

  #dateOfServiceCol {
    width: 65px;
  }

  #dateOfServiceCol a span,
  #youResponsbilityCol a span {
    font-size: 12px;
  }

  .tableFormat.responsiveCustomTable td,
  .tableFormat.responsiveCustomTable th {
    padding: 15px 2px;
    font-size: 12px;
  }

  .tableFormat.responsiveCustomTable th {
    padding: 15px 6px;
    font-size: 12px;
  }

  .tableFormat.responsiveCustomTable td span {
    padding: 15px 0;
    font-size: 12px;
  }

  .tableIncentive .dataGridTableHeader th,
  .tableIncentive tbody tr td {
    padding: 20px 0 20px 10px;
  }
}

@media (max-width: 420px) {
  .tableIncentive .dataGridTableHeader th,
  .tableIncentive tbody tr td {
    padding: 20px 2px;
  }

  .tableIncentive {
    margin-left: 0;
  }

  .tableIncentive .dataGridTableHeader th {
    padding-bottom: 5px;
  }
}

.claimsDataGridText {
  font-weight: 700;
}

:root .pricarephy .panel-group .panel-heading a .plus_minus,
_:-ms-fullscreen {
  padding: 0 7px;
}

.floatMeLeft {
  float: left;
}

.aetLogoMargin {
  margin-left: 0;
}

.padding-top-id {
  padding-top: 2%;
}

.idCardMargin {
  margin-left: 10px;
}

.idCardMargin:after {
  content: "\\a";
  white-space: pre;
}

.noPull {
  float: none !important;
}

.carotSpace {
  padding-left: 6px;
}

@media (min-width: 992px) and (max-width: 1200px) {
  .container,
  .container1 {
    width: auto !important;
  }
}

@media (max-width: 992px) {
  .second-navigation a,
  .second-navigation p {
    margin: 3%;
  }
}

.global-overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #646464;
  background-color: hsla(0, 0%, 39%, 0.9);
  overflow-x: hidden;
  transition: 0.5s;
}

.global-overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

.global-overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.global-overlay a:focus,
.global-overlay a:hover {
  color: #f1f1f1;
}

.global-overlay .overlay-closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}

@media screen and (max-height: 450px) {
  .global-overlay a {
    font-size: 20px;
  }

  .global-overlay .overlay-closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}

.redErr {
  color: #d20962 !important;
}

.navigator-logos {
  width: 100%;
  margin-top: 15px;
  margin-left: 15px;
}

@media (min-width: 1295px) {
  .topChromeLogo {
    width: 1300px !important;
  }
}

.topPositionCalIcon {
  top: 30% !important;
}

@media (max-width: 992px) {
  .nav > li > a:focus,
  .nav > li > a:hover {
    text-decoration: none;
    background-color: transparent;
  }
}

.innerListFAQ {
  padding-left: 50px !important;
}

.eobBtn {
  white-space: normal !important;
}

.tabOpen {
  margin-left: 5%;
  display: none;
  width: 60%;
  background-color: #0d8ba7;
  font-weight: 800;
  padding: 4px;
}

.tabOpenDesktop {
  margin-left: 20px;
  background-color: #7d3f98;
  padding: 10px 15px;
  color: #fff !important;
  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.3);
  display: inline-block;
  border: 0;
  margin-top: 7px;
}

.modalEOB {
  display: none;
  position: fixed;
  z-index: 10;
  padding-top: 300px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-contentEOB {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 40%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: g;
  -webkit-animation-duration: 0.4s;
  animation-name: g;
  animation-duration: 0.4s;
}

.closeEOB {
  color: #fff;
  float: right;
  font-size: 16px;
  font-weight: 700;
}

.closeEOB:focus,
.closeEOB:hover {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.modal-headerEOB {
  padding: 2px 16px;
  background-color: #7d3f98;
  color: #fff;
  height: 40px;
}

.modal-bodyEOB {
  padding: 20px;
  height: 100px;
}

.modal-footerEOB {
  padding-top: 23px;
  text-align: center;
  background-color: #fff;
  color: #fff;
}

.buttonEOBOK {
  background-color: #7d3f98;
  border: none;
  color: #fff !important;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 80px 200px 15px;
  cursor: pointer;
}

.modalEOBAndroid {
  display: none;
  position: fixed;
  z-index: 1;
  padding-top: 125px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-contentEOBAndroid {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 85%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: g;
  -webkit-animation-duration: 0.4s;
  animation-name: g;
  animation-duration: 0.4s;
}

@keyframes g {
  0% {
    top: -300px;
    opacity: 0;
  }

  to {
    top: 0;
    opacity: 1;
  }
}

.closeEOBAndroid {
  color: #fff;
  float: right;
  font-size: 16px;
  font-weight: 700;
}

.closeEOBAndroid:focus,
.closeEOBAndroid:hover {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.modal-headerEOBAndroid {
  padding: 2px 16px;
  background-color: #076f86;
  color: #fff;
  height: 40px;
}

.modal-bodyEOBAndroid {
  padding: 20px;
  height: 100px;
}

.modal-footerEOBAndroid {
  padding: 2px 16px;
  background-color: #fff;
  color: #fff;
  height: 150px;
}

.buttonEOBOKAndroid {
  background-color: #076f86;
  border: none;
  color: #fff !important;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 25%;
  cursor: pointer;
}

@media (max-width: 992px) {
  .menuTopChrome,
  .originalTopChromeLinks {
    display: none;
  }
}

@media (min-width: 992px) {
  .menuTopChrome {
    padding-right: 25px;
    padding-left: 25px;
    display: inline-block;
    border-right: 2px solid grey;
    margin-bottom: 15px;
  }

  .menuLinkTopChrome {
    color: #7d3f98 !important;
  }

  .home-util {
    display: none !important;
  }

  .originalTopChromeLinks {
    margin: 0;
    background-color: #7d3f98 !important;
    margin-top: -6px;
    margin-bottom: -6px;
  }

  .logoutButton {
    float: right !important;
    padding: 14px !important;
    margin-right: 30px !important;
  }

  .logoutButton,
  .logoutButton:focus,
  .logoutButton:hover {
    color: #fff !important;
  }

  .bottom_chrome_link {
    background: #7d3f98;
    text-align: center;
    display: inline-block;
  }

  .navbar-nav {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .topChromeLogo {
    width: 100% !important;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    display: inline-block;
  }

  .divMenuTopChrome {
    width: 100%;
    font-size: 16px;
  }

  #adjustPSLogo,
  .divMenuTopChrome {
    display: inline-block;
    text-align: center;
  }

  #adjustPSLogo {
    width: 100% !important;
  }

  .top_chrome_link {
    margin-right: 30%;
    padding-top: 20px;
    color: #7d3f98 !important;
  }

  .top_welcome_link {
    font-size: 17px;
  }

  .top_welcome_link:after {
    content: "\\a";
    white-space: pre;
  }

  #aet-content-hdrtxtone,
  .visiblityHide {
    visibility: hidden;
  }

  .navbar-default .navbar-nav > li:first-child > a {
    margin-top: -80px;
  }

  .badge {
    margin-top: 0 !important;
  }

  .line-seperator {
    display: none;
  }

  .aet-content-header .aet-cont-hdrtxt {
    margin-left: 50% !important;
  }

  .aet-content-header .aet-cont-hdrtxt,
  .aet-content-header .aet-cont-hdrtxtNew {
    font-size: 32px !important;
    width: 100% !important;
    text-align: center;
    font-family: Domaine display !important;
  }

  .aet-content-header .aet-cont-hdrtxtNew {
    color: #fff;
    padding: 10px 0;
    font-family: domaine display !important;
  }

  .navbar-nav > li > a {
    color: #fff !important;
  }

  .nav > li > a:focus,
  .nav > li > a:hover {
    text-decoration: none;
    background-color: transparent !important;
  }

  .second-navigation {
    text-align: left;
    height: 61px;
    z-index: 2;
    background-color: #eee;
    border-bottom: 2px solid #7d3f98 !important;
  }

  .collapse.navbar-collapse {
    margin-right: 0;
    min-width: 25%;
  }
}

@media (max-width: 992px) {
  .nav-mobile-list {
    display: inline-flex;
  }

  .badge {
    background: #b18cc0;
  }

  .navigator-logos {
    margin-left: 35%;
    margin-top: 1% !important;
    margin-bottom: -19% !important;
  }

  .sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 9999999999;
    top: 0;
    left: 0;
    background-color: #7d3f98;
    overflow-x: hidden;
    transition: 0.2s;
    padding-top: 60px;
  }

  .sidenav .menu-list a,
  .sidenav .menu-list p {
    text-decoration: none;
    font-size: 16px;
    color: #fff !important;
    display: block;
    transition: 0.2s;
  }

  .sidenav a:hover {
    color: #f1f1f1;
  }

  .entireWarpper {
    transition: margin-left 0.2s;
  }

  @media screen and (max-height: 450px) {
    .sidenav {
      padding-top: 15px;
    }

    .sidenav a {
      font-size: 18px;
    }
  }

  ul.menu-list li {
    margin: 0;
    padding: 0 !important;
  }

  .home-mobile-list li img,
  .menu-list li a img.left-img {
    display: none;
  }

  .mobile-list-new {
    margin-left: 36px !important;
    padding-left: 0 !important;
  }

  ul.menu-list li.home-mobile-list ul li {
    padding: 2px 7px !important;
    border-bottom: 0;
  }

  .menu-list {
    background-color: #7d3f98;
    border-bottom: 0 solid #fff;
  }

  .menu-list li.inactive {
    background-color: #602978;
    padding: 0 !important;
  }

  ul.menu-list li {
    background: transparent;
  }

  ul.menu-list li.home-mobile-list {
    border-top: 1px solid #602978;
    padding-top: 10px !important;
    margin-top: 20px !important;
  }

  .unbindRedundantClick {
    display: block;
    background: #602978;
  }

  ul.menu-list li a {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  ul.menu-list li a span {
    color: #fff;
  }

  .menu-txt,
  .mobileClick img {
    display: none;
  }

  .close-menu {
    margin-left: 85% !important;
    height: 150% !important;
  }

  .home-mobile-menu {
    display: none;
  }

  .menu-button {
    background: transparent;
    width: 35px;
    padding: 2px !important;
    margin: 1%;
    margin-top: 1px;
  }

  .navigator-logos img {
    width: 84px;
    margin-left: -5% !important;
  }

  .homeLinkOnMenu {
    margin-left: 17%;
    font-size: 18px !important;
    padding-bottom: 15px;
  }

  .PharmacyLinkOnMenu {
    margin-left: 17%;
  }

  .rotateMenu {
    transform: rotate(90deg);
    transition: 0.1s;
  }

  .aet-content-header .aet-cont-hdrtxt {
    margin-left: 10% !important;
    width: 100%;
    text-align: center;
    font-family: domaine display !important;
  }

  ul.menu-list li.home-mobile-list ul li .badge {
    background: #fff;
    color: #7d3f98;
    margin-top: -1px !important;
  }

  .home_master_tab_group .nav-tabs,
  .home_master_tab_group .nav-tabs > li > a {
    background: #eee !important;
  }

  section {
    background-color: #eee !important;
  }

  .forms-navigation {
    text-align: center;
  }
}

@media (min-width: 992px) {
  .second-navigation a,
  .second-navigation p {
    font-size: 16px !important;
    margin: 0.5% !important;
    font-weight: 700 !important;
  }

  .sidenav {
    display: none;
  }

  .forms-navigation {
    text-align: center;
  }

  .aet-footer .aet-footer-nav li {
    float: left;
    width: 20%;
    border: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .aet-footer-logo .noPull a img {
    margin-top: -60px;
  }

  .aet-footer .aet-footer-nav {
    width: 90% !important;
  }

  .navigator-logos .aet-logo img {
    visibility: visible;
  }

  .menu-button {
    display: none !important;
  }

  ul li a span.font21 {
    font-size: 21px;
    font-weight: 400;
    color: #fff;
  }

  ul li a span.font-16 {
    font-size: 18px !important;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .topChromeLogout {
    position: absolute !important;
    margin-left: 85px !important;
    width: 100px;
  }

  .home_group img {
    margin-top: -20% !important;
  }

  .noHighlight .left-block > p.marT10 {
    margin-top: 7%;
  }

  ul li a span.font-16 {
    font-size: 16px !important;
  }
}

@media (max-width: 500px) {
  .tile_seperator .marT10 li {
    padding-right: 20px !important;
  }
}

@media (max-width: 991px) {
  ul li a span.font-16 {
    font-size: 18px !important;
    margin-left: -25px !important;
  }

  ul li a span.font21 {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }

  .nav-tabs > li.home_group {
    padding-left: 0;
    padding-right: 0;
    border: 1px solid #ccc;
    background: #fff !important;
    box-shadow: 0 0 1.5px 0.5px #ccc;
    margin-bottom: 10px;
  }

  .home_master_tab_group .nav-tabs > li > a,
  .noHighlight {
    background: #7d3f98 !important;
  }

  .noHighlight {
    height: 45px !important;
  }

  .home_group .tile_seperator {
    border-top: 0 solid;
    margin-top: 10%;
  }

  .noHighlight .left-block .font-16 {
    color: #fff;
    font-size: 18px;
    font-weight: 400;
  }

  .nav-tabs > li > a {
    border-radius: 0 0 0 0 !important;
  }

  .home_group img {
    margin-top: -35%;
    width: 40px;
  }

  .noHighlight .left-block > p.marT10 {
    margin-top: -2%;
    margin-left: 20%;
  }

  #home_tab_accordion {
    background: transparent !important;
  }

  .tile_seperator .marT10 li {
    float: left;
    width: 50%;
    padding: 5px 0 7px;
  }

  .tile_seperator .marT10 li li,
  .tile_seperator .marT10 li li:last-child {
    padding: 0;
  }

  .tile_seperator .marT10 li:last-child {
    padding-bottom: 15px;
  }

  .home_master_tab_group .nav-tabs > li > a.pos-rel-block {
    padding: 13px 0 0 24px !important;
  }

  .tile_seperator .marT10 li a {
    color: #7d3798 !important;
    font-size: 14px;
    font-weight: 400;
  }

  .home_group .buttonpad {
    padding: 0 !important;
    display: inline-block;
    font-size: 16px;
    margin-bottom: 3%;
    float: left;
    margin-left: 10%;
    background: #fff !important;
    color: #7d3798 !important;
    margin-left: 0 !important;
  }

  .noHighlight .left-block {
    float: none;
    width: 100%;
  }

  .sidenav .left-block {
    float: left;
    width: 68%;
    margin-left: 17%;
  }

  .aet-footer .aet-footer-nav li {
    float: left;
    width: 50%;
    border-left: 0 none !important;
  }

  .aet-content-header.canbpink-header,
  .second-navigation a.canbLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.canbLevel:after {
    border-top: 10px solid #7d3f98;
  }

  .aet-content-header.blue-header,
  .second-navigation a.blueLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.blueLevel:after {
    border-top: 10px solid #7d3f98;
  }

  .aet-content-header.tealgreen-header,
  .second-navigation a.tealLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.tealLevel:after {
    border-top: 10px solid #7d3f98;
  }

  .aet-content-header.green-header,
  .second-navigation a.greenLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.greenLevel:after {
    border-top: 10px solid #7d3f98;
  }
}

@media (min-width: 991px) {
  .inline-home-block a.fontsize24 {
    color: #7d3f98 !important;
  }

  .green-patch {
    background: #b18cc0 !important;
    color: #000 !important;
    width: 90%;
    font-weight: 700;
    height: 34px;
    padding: 5px 10px !important;
  }

  .inline-home-block p.grey-patch {
    background: #fff !important;
  }

  .inline-home-block a.fontsize20 {
    color: #7d3f98 !important;
    font-size: 16px;
  }

  .second-navigation a,
  .second-navigation p {
    color: #0c0101;
    background-color: #b18cc0;
  }

  .col-md-12 .fontsize24 {
    font-weight: 700;
    color: #000 !important;
  }

  .teladoc {
    border: 1px solid #ccc;
    box-shadow: 0 0 0;
    margin: 10px 25px 20px -4px;
    height: 215px;
    background-color: #fff;
    width: 48% !important;
  }

  .teladoc .left-icon img {
    width: 35%;
    margin-top: -13px;
    margin-left: 13px;
  }

  .teladocWiththree {
    border: 1px solid #eee;
    box-shadow: 0 0 0;
    margin: 10px 25px 20px -4px;
    height: 275px;
    background-color: #fff;
    width: 31.6% !important;
  }

  .para-left-border .teladocWiththree .left-icon img,
  .teladocWiththree .left-icon img {
    width: 55%;
    margin-top: -13px;
    margin-left: 3px;
  }

  .font24 {
    font-size: 24px;
  }

  .col-md-12 .marL25 {
    text-align: center;
    margin-right: -4px !important;
  }

  .col-md-12 .marT25 .bold {
    display: none !important;
  }

  .coverage-page-bg {
    background-color: #eee !important;
    margin-top: -26px;
  }

  .home-hdr-value-new a {
    font-weight: 700 !important;
    display: block;
    margin: 5px 0;
  }

  .home-hdr-value-new .inline-para a,
  .home-hdr-value-new a,
  .labelFont {
    color: #7d3f98 !important;
  }

  .labelFont {
    font-size: 24px;
    margin-left: -10px !important;
  }

  .hrline {
    width: 110%;
    margin-left: -40px;
    border-top: 2px solid;
    border-top-color: #b18cc0 !important;
    font-size: 16px;
  }

  .paNurseLine {
    border-bottom: 2px solid;
    margin-left: 0;
    border-top: 0 solid;
    border-bottom-color: #b18cc0 !important;
    margin-top: 4px;
  }

  .otherpa {
    float: none;
    margin-left: 25px;
  }

  .inline-para {
    font-size: 16px;
  }

  .aet-content-header.canbpink-header,
  .second-navigation a.canbLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.canbLevel:after {
    border-top: 10px solid #7d3f98;
  }

  .aet-content-header.blue-header,
  .second-navigation a.blueLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.blueLevel:after {
    border-top: 10px solid #7d3f98;
  }

  .aet-content-header.tealgreen-header,
  .second-navigation a.tealLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.tealLevel:after {
    border-top: 10px solid #7d3f98;
  }

  .aet-content-header.green-header,
  .second-navigation a.greenLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.greenLevel:after {
    border-top: 10px solid #7d3f98;
  }
}

@media (max-width: 991px) {
  .inline-home-block a.fontsize24 {
    color: #7d3f98 !important;
  }

  .green-patch {
    background: #b18cc0 !important;
    color: #000 !important;
    width: 90%;
    font-weight: 700;
    height: 34px;
    padding: 5px 10px !important;
  }

  .inline-home-block p.grey-patch {
    background: #fff !important;
  }

  .inline-home-block a.fontsize20 {
    color: #7d3f98 !important;
    font-size: 14px;
  }

  .second-navigation a.canbLevel {
    background-color: #7d3f98;
  }

  .second-navigation a.canbLevel:after {
    border-top: 10px solid #7d3f98;
  }

  .second-navigation a,
  .second-navigation p {
    color: #0c0101;
    background-color: #b18cc0;
  }

  .col-md-12 .fontsize24 {
    font-weight: 700;
    color: #000 !important;
  }

  .teladoc {
    border: 1px solid #ccc;
  }

  .teladoc,
  .teladocWiththree {
    box-shadow: 0 0 0;
    margin: 10px 0 20px;
    height: 320px;
    background-color: #fff;
    width: 100% !important;
  }

  .teladocWiththree {
    border: 1px solid #eee;
  }

  .teladoc .left-icon img,
  .teladocWiththree .left-icon img {
    width: 70%;
    margin-top: -13px;
    margin-left: 2px;
  }

  .col-md-12 .marL25 {
    text-align: center;
    margin-right: -4px !important;
  }

  .col-md-12 .marT25 .bold {
    display: none !important;
  }

  .coverage-page-bg {
    background-color: #eee !important;
    margin-top: -26px;
  }

  .home-hdr-value-new a {
    color: #000 !important;
    font-weight: 700 !important;
    display: block;
    margin: 5px 0;
    font-size: medium;
    margin-bottom: 4% !important;
  }

  .home-hdr-value-new .inline-para a {
    color: #7d3f98 !important;
  }

  .hrline {
    width: 107%;
    margin-left: -13%;
    border-top: 2px solid;
    border-top-color: #b18cc0 !important;
    font-size: 15px;
  }

  .paNurseLine {
    border-bottom: 2px solid;
    margin-left: -3%;
    margin-bottom: 2% !important;
    border-top: 0 solid;
    padding-bottom: 10px !important;
    border-bottom-color: #b18cc0 !important;
    font-size: 16px !important;
  }

  .otherpa {
    float: none;
    margin-left: 25px;
    margin-top: 10px;
  }

  .home-blocks .bg-white.col-md-4 {
    width: 108% !important;
    margin-left: 0 !important;
  }

  .entireWarpper {
    background-color: #eee;
  }

  .coverage-page-bg .aet-template .home-blocks {
    margin-left: -15px;
  }

  .inline-para {
    font-size: 16px;
    width: 108% !important;
  }
}

@media only screen and (min-width: 500px) and (max-width: 991px) {
  .teladoc .left-icon img {
    width: 23%;
    margin-top: -10px;
    margin-left: 17px;
  }

  .teladocWiththree .left-icon img {
    width: 28%;
    margin-top: -10px;
    margin-left: 17px;
  }

  .teladoc {
    height: 240px;
  }

  .teladocWiththree {
    height: 320px;
  }

  .paNurseLine {
    margin-left: 0;
    margin-top: 15px !important;
  }

  .hrline {
    margin-top: -8px;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1150px) {
  .teladoc .left-icon img {
    width: 23%;
    margin-top: -10px;
    margin-left: 17px;
  }

  .teladocWiththree {
    border: 1px solid #eee;
    box-shadow: 0 0 0;
    margin: 8x 25px 20px -4px;
    height: 285px;
    background-color: #fff;
    width: 31% !important;
  }

  .teladocWiththree .fontsize24 {
    font-weight: 700;
    color: #000 !important;
    font-size: 16px;
  }

  .hrline {
    width: 100%;
    font-size: 16px;
  }

  .otherpa {
    float: none;
    margin-left: 20px;
  }

  .home-hdr-value-new .left-icon {
    margin-top: 14px;
    padding-left: 10px !important;
  }

  .teladocWiththree .left-icon img {
    width: 42%;
    margin-top: -10px;
    margin-left: 15px;
  }

  .teladoc {
    height: 240px;
  }

  .teladocWiththree {
    height: 320px;
  }

  .paNurseLine {
    margin-left: 0;
    margin-top: 15px !important;
  }

  .hrline {
    margin-top: -8px;
  }
}

#payflexTab {
  background: #7d3f98;
}

@media (min-width: 991px) {
  .topChromeLogout {
    position: absolute !important;
    margin-left: 200px;
    width: 100px;
  }

  .benefits_Overview .pha-hdr-txt {
    color: purple !important;
    margin-left: -12px !important;
  }

  .benefits_Overview .pha-hdr-txt.black-text,
  .infogramHead a {
    color: #7d3f98 !important;
  }

  .home-blocks {
    box-shadow: 0 0 0;
    margin: 2px 0 17px 2px;
    background-color: #eee;
    width: 100% !important;
  }

  .benefits_Overview .mrgnT20 {
    background-color: #f8f8f8 !important;
  }

  .home-blocks .bg-white .services-list {
    background: #fff !important;
    border: 1px solid #ffff !important;
  }

  .border-top-purple {
    border-top: 2px solid #7d3f98 !important;
    margin-top: -11px;
  }

  .printOverviewDisplay a img {
    width: 8%;
  }

  #My_Coverage {
    margin-top: 39px;
    height: 1080px;
  }

  #select-member-name {
    height: 33px;
  }

  .Cov1 {
    width: 102%;
    margin-left: -4px;
  }

  .Cov3 {
    width: 100%;
    margin-left: -19px;
  }

  .infogramHead a {
    font-weight: 400 !important;
  }

  .rem {
    margin-left: -312px;
  }

  .rem,
  .remDen {
    background-color: transparent;
    box-shadow: 0 0 0 0 #9e9e9e;
    margin-top: 80px;
    margin-bottom: 12px;
  }

  .remDen {
    margin-left: -290px;
  }

  .remAhf {
    background-color: transparent;
    box-shadow: 0 0 0 0 #9e9e9e;
    margin-top: 90px;
    margin-left: -305px;
    margin-bottom: 12px;
  }
}

@media screen and (max-width: 991px) {
  .benefits_Overview .pha-hdr-txt {
    color: purple !important;
    margin-left: -12px !important;
    font-size: 22px;
  }

  .benefits_Overview .pha-hdr-txt.black-text,
  .infogramHead a {
    color: purple !important;
  }

  .home-blocks {
    box-shadow: 0 0 0;
    margin: 2px 0 17px 2px;
    background-color: #eee;
    width: 100% !important;
  }

  .benefits_Overview .mrgnT20 {
    background-color: #f8f8f8 !important;
  }

  .home-blocks .bg-white .services-list {
    background: #fff !important;
    border: 1px solid #ffff !important;
  }

  .border-top-purple {
    border-top: 2px solid #7d3f98 !important;
    margin-top: -11px;
  }

  .printOverviewDisplay a img {
    width: 8%;
  }

  #My_Coverage {
    margin-top: 39px;
    height: 1050px;
  }

  #select-member-name {
    height: 33px;
  }

  .Cov1 {
    width: 102%;
    margin-left: -4px;
  }

  .Cov3 {
    width: 108%;
    margin-left: -19px;
  }

  .infogramHead a {
    font-weight: 400 !important;
  }

  .rem,
  .remDen {
    margin-top: 40px;
  }

  .rem,
  .remAhf,
  .remDen {
    background-color: transparent;
    box-shadow: 0 0 0 0 #9e9e9e;
    margin-bottom: 12px;
  }

  .remAhf {
    margin-top: 45px;
  }

  .second-navigation a {
    border-bottom: 0 solid #7d3f98 !important;
  }
}

.second-navigation a {
  border-bottom: 1px solid #7d3f98 !important;
}

#carouselButtons {
  margin-left: 47%;
  position: absolute;
  bottom: 50px;
  z-index: 15;
}

#homeCarousel {
  height: 360px;
}

.carousel-indicators .active {
  width: 12px;
  height: 12px;
  margin: 0;
  background-color: #7d3f98;
}

.carousel-indicators li {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1px;
  text-indent: -999px;
  cursor: pointer;
  /* background-color: #000\\9;*/
  background-color: #b18cc0;
  border: 0 solid #7d3f98;
  border-radius: 10px;
}

.carousel-indicators {
  position: absolute;
  bottom: -5px;
  left: 50%;
  z-index: 15;
  width: 60%;
  padding-left: 0;
  margin-left: -30%;
  text-align: center;
  list-style: none;
}

#pauseButton,
#playButton {
  color: #7d3f98;
  cursor: pointer;
  position: absolute;
}

.psImageWidth {
  font-size: 15px;
  color: #7d3f98;
}

.inline-para[nvstyle="planSponserBannerParagraph2"] {
  color: #414141;
}

.alignPara {
  display: inline-block;
  margin-right: 2%;
  color: #7d3f98;
}

.sponsor-block img {
  margin: 0 !important;
  padding: 0;
  vertical-align: initial;
}

.sponsor_details {
  box-shadow: 0 0 1.5px 0.5px grey;
}

@media screen and (max-width: 991px) {
  #homeCarousel {
    height: 415px;
  }

  #carouselButtons {
    margin-left: 40%;
    position: absolute;
    bottom: 50px;
    z-index: 9999;
  }

  .carousel-indicators {
    bottom: -12px;
    width: 54%;
  }
}

.white-bg-mail-address {
  background: #eee !important;
  margin: 20px 0;
}

.align-lang-assist {
  padding-right: 53px;
}

.footer-langAssistant {
  margin-top: 75px;
  font-size: 14px;
}

.footer-langAssistant > a,
.footer-langAssistant > a > span {
  color: #7d3f98;
  font-weight: 700;
  font-size: 16px;
  padding-left: 0 !important;
  float: none !important;
}

#alignLangAssistantLink {
  text-align: left;
}

@media (max-width: 767px) {
  .aet-footer-logo {
    padding: 10px 0;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .topChromeLogout {
    position: absolute !important;
    margin-left: 85px !important;
    width: 100px;
  }

  .navbar-default .navbar-nav > li:first-child > a {
    margin-top: -60px;
  }

  .home_group .tile_seperator {
    border-top: 0 solid;
    margin-top: 3%;
  }

  .home_group img {
    margin-top: -10% !important;
    padding-right: 10px;
  }

  .noHighlight .left-block > p.marT10 {
    margin-top: -1%;
  }

  .home_master_tab_group .nav-tabs > li > a.pos-rel-block {
    margin-top: -10px;
    float: left;
  }

  a[nvstyle="green"] img {
    margin-top: -5px !important;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .noHighlight .left-block > p.marT10 {
    margin-top: 7%;
    margin-left: 20%;
  }

  .navbar-default .navbar-nav > li:first-child > a {
    margin-top: -60px;
  }

  ul li a span.font-16 {
    font-size: 16px !important;
    font-weight: 400 !important;
  }

  .alignPara,
  .inline-para {
    font-size: 14px;
  }

  a[nvstyle="marqueeLinkReadMore"] {
    padding-left: 26%;
    padding-right: 26%;
  }

  .teladoc {
    height: 235px;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (orientation: landscape) {
  .home_group img {
    margin-top: -16%;
    width: 25px;
  }

  .home_group .tile_seperator {
    margin-top: 5%;
  }

  .noHighlight .left-block > p.marT10 {
    margin-top: -1%;
    margin-left: 10%;
  }
}

@media (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .navbar-default .navbar-nav > li:first-child > a {
    margin-top: -57px !important;
  }
}

@media (max-width: 991px) {
  .border-top-color-Sponsor-Links {
    border-top: none !important;
    text-align: center;
  }

  .sponsor-block h2 {
    font-weight: 700 !important;
  }
}

@media (min-width: 992px) {
  #eobPages {
    font-size: 0 !important;
  }

  .topChromeLogoutAlign {
    position: absolute !important;
    margin-left: 100px;
    width: 100px;
  }

  .center-btn {
    display: block;
    margin-right: auto;
    margin-left: auto;
  }
}

#myVideoBtn {
  top: 20px;
  background-color: #7d3f98;
}

.sideVideoLink {
  color: #fff;
  font-size: 28px;
  top: 8px;
}

.sundayAPV {
  text-align: center !important;
}

.title {
  font-size: 16px;
  color: #414141;
  font-weight: 700;
}

.center-align {
  text-align: center;
}

.ahText-Color {
  color: #7d3798;
}

.showEmailLeft,
.showFaxLeft {
  line-height: normal !important;
}

#displaySharePopup {
  overflow: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/comon.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,yMAAyM;EACzM,mGAAmG;EACnG,4EAA4E;EAC5E,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,0DAA0D;EAC1D,yDAAyD;EACzD,uDAAuD;EACvD,8BAA8B;EAC9B,0CAA0C;EAC1C,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;EACd,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAE7B,gBAAgB;;EAEhB,MAAM;EACN,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,yMAAyM;EACzM,mGAAmG;EACnG,4EAA4E;EAC5E,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,0DAA0D;EAC1D,yDAAyD;EACzD,uDAAuD;EACvD,8BAA8B;EAC9B,0CAA0C;EAC1C,sBAAsB;EACtB,mCAAmC;EACnC,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;EACd,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,yMAAyM;EACzM,mGAAmG;EACnG,4EAA4E;EAC5E,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,0DAA0D;EAC1D,yDAAyD;EACzD,uDAAuD;EACvD,8BAA8B;EAC9B,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,8BAAgD;EAChD,WAAW;EACX,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;;;EAGE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,yMAAyM;EACzM,mGAAmG;EACnG,4EAA4E;EAC5E,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,0DAA0D;EAC1D,yDAAyD;EACzD,uDAAuD;EACvD,8BAA8B;EAC9B,0CAA0C;EAC1C,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,8BAAgD;EAChD,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,yDAAyD;AAC3D;;;;AAIA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,yMAAyM;EACzM,mGAAmG;EACnG,4EAA4E;EAC5E,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,0DAA0D;EAC1D,yDAAyD;EACzD,uDAAuD;EACvD,8BAA8B;EAC9B,0CAA0C;EAC1C,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;EACd,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,yMAAyM;EACzM,mGAAmG;EACnG,4EAA4E;EAC5E,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,0DAA0D;EAC1D,yDAAyD;EACzD,uDAAuD;EACvD,8BAA8B;EAC9B,0CAA0C;EAC1C,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;EACd,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,iCAAiC;AACnC;;AAEA;;;;;EAKE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;;EAKE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;;EAEE,yFAAyF;EACzF,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oFAAoF;EACpF,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,2FAA2F;EAC3F,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,sFAAsF;EACtF,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE;iBACe;EACf,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,QAAQ;EACR,aAAa;AACf;;AAEA;;EAEE,yGAAyG;EACzG,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,uGAAuG;EACvG,aAAa;AACf;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;;;;EAKE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,wCAAwC;EAC1C;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,oDAAoD;AACtD;;;;AAIA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,SAAS;EACX;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,MAAM;IACN,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,yFAAyF;EACzF,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,MAAM;EACN,QAAQ;EACR,SAAS;AACX;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;IAC5C,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;;EAEA;;IAEE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,eAAe;EACf,UAAU;EACV,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,qBAAqB;IACrB,6BAA6B;EAC/B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,4EAA4E;EAC5E,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,UAAU;EACV,4EAA4E;EAC5E,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,MAAM;IACN,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uCAAuC;EACzC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,SAAS;IACT,qBAAqB;EACvB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;IACd,aAAa;EACf;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,oCAAoC;IACpC,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,oCAAoC;IACpC,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,+BAA+B;IAC/B,uCAAuC;IACvC,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,wCAAwC;IACxC,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,wCAAwC;IACxC,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,6BAA6B;IAC7B,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".screen-reader-hidden {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n#site-header{\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13,110,253;\n  --bs-secondary-rgb: 108,117,125;\n  --bs-success-rgb: 25,135,84;\n  --bs-info-rgb: 13,202,240;\n  --bs-warning-rgb: 255,193,7;\n  --bs-danger-rgb: 220,53,69;\n  --bs-light-rgb: 248,249,250;\n  --bs-dark-rgb: 33,37,41;\n  --bs-white-rgb: 255,255,255;\n  --bs-black-rgb: 0,0,0;\n  --bs-body-color-rgb: 33,37,41;\n  --bs-body-bg-rgb: 255,255,255;\n  --bs-font-sans-serif: system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-bg: #fff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0,0,0,.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #0d6efd;\n  --bs-link-hover-color: #0a58ca;\n  --bs-code-color: #d63384;\n  --bs-highlight-bg: #fff3cd;\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  text-align: var(--bs-body-text-align);\n  color: #414141;\n  font-family: CVS-reg,sans-serif;\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgba(59,130,246,.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  box-sizing: border-box;\n  background: #fff;\n  border-bottom: 3px solid #ddd;\n  position: -webkit-sticky;\n  position: sticky;\n\n  top: 0;\n  width: 100%;\n  z-index: 15;\n}\n\n#site-header > .upper-nav{\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13,110,253;\n  --bs-secondary-rgb: 108,117,125;\n  --bs-success-rgb: 25,135,84;\n  --bs-info-rgb: 13,202,240;\n  --bs-warning-rgb: 255,193,7;\n  --bs-danger-rgb: 220,53,69;\n  --bs-light-rgb: 248,249,250;\n  --bs-dark-rgb: 33,37,41;\n  --bs-white-rgb: 255,255,255;\n  --bs-black-rgb: 0,0,0;\n  --bs-body-color-rgb: 33,37,41;\n  --bs-body-bg-rgb: 255,255,255;\n  --bs-font-sans-serif: system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-bg: #fff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0,0,0,.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #0d6efd;\n  --bs-link-hover-color: #0a58ca;\n  --bs-code-color: #d63384;\n  --bs-highlight-bg: #fff3cd;\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  text-size-adjust: 100%;\n  -webkit-font-smoothing: antialiased;\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  text-align: var(--bs-body-text-align);\n  color: #414141;\n  font-family: CVS-reg,sans-serif;\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgba(59,130,246,.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  box-sizing: border-box;\n}\nbutton.hamburger.hamburger--squeeze\n.hamburger-inner{\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13,110,253;\n  --bs-secondary-rgb: 108,117,125;\n  --bs-success-rgb: 25,135,84;\n  --bs-info-rgb: 13,202,240;\n  --bs-warning-rgb: 255,193,7;\n  --bs-danger-rgb: 220,53,69;\n  --bs-light-rgb: 248,249,250;\n  --bs-dark-rgb: 33,37,41;\n  --bs-white-rgb: 255,255,255;\n  --bs-black-rgb: 0,0,0;\n  --bs-body-color-rgb: 33,37,41;\n  --bs-body-bg-rgb: 255,255,255;\n  --bs-font-sans-serif: system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-bg: #fff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0,0,0,.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #0d6efd;\n  --bs-link-hover-color: #0a58ca;\n  --bs-code-color: #d63384;\n  --bs-highlight-bg: #fff3cd;\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  color: inherit;\n  font: inherit;\n  text-transform: none;\n  cursor: pointer;\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgba(59,130,246,.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  box-sizing: border-box;\n  display: block;\n  margin-top: -2px;\n  top: 50%;\n  background-color: #000;\n  border-radius: 4px;\n  height: 4px;\n  position: absolute;\n  transition-property: transform,-webkit-transform;\n  width: 40px;\n  transition-duration: 75ms;\n  transition-timing-function: cubic-bezier(.55,.055,.675,.19);\n}\n\nbutton.hamburger.hamburger--squeeze.is-active \n.hamburger-inner\n{\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13,110,253;\n  --bs-secondary-rgb: 108,117,125;\n  --bs-success-rgb: 25,135,84;\n  --bs-info-rgb: 13,202,240;\n  --bs-warning-rgb: 255,193,7;\n  --bs-danger-rgb: 220,53,69;\n  --bs-light-rgb: 248,249,250;\n  --bs-dark-rgb: 33,37,41;\n  --bs-white-rgb: 255,255,255;\n  --bs-black-rgb: 0,0,0;\n  --bs-body-color-rgb: 33,37,41;\n  --bs-body-bg-rgb: 255,255,255;\n  --bs-font-sans-serif: system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-bg: #fff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0,0,0,.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #0d6efd;\n  --bs-link-hover-color: #0a58ca;\n  --bs-code-color: #d63384;\n  --bs-highlight-bg: #fff3cd;\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  color: inherit;\n  font: inherit;\n  text-transform: none;\n  cursor: pointer;\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgba(59,130,246,.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  box-sizing: border-box;\n  display: block;\n  margin-top: -2px;\n  top: 50%;\n  border-radius: 4px;\n  height: 4px;\n  position: absolute;\n  transition-property: transform,-webkit-transform;\n  width: 40px;\n  transition-duration: 75ms;\n  background-color: #000;\n  transform: rotate(45deg);\n  transition-delay: .12s;\n  transition-timing-function: cubic-bezier(.215,.61,.355,1);\n}\n\n\n\n#mySidenav.nav-wrapper.open{\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13,110,253;\n  --bs-secondary-rgb: 108,117,125;\n  --bs-success-rgb: 25,135,84;\n  --bs-info-rgb: 13,202,240;\n  --bs-warning-rgb: 255,193,7;\n  --bs-danger-rgb: 220,53,69;\n  --bs-light-rgb: 248,249,250;\n  --bs-dark-rgb: 33,37,41;\n  --bs-white-rgb: 255,255,255;\n  --bs-black-rgb: 0,0,0;\n  --bs-body-color-rgb: 33,37,41;\n  --bs-body-bg-rgb: 255,255,255;\n  --bs-font-sans-serif: system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-bg: #fff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0,0,0,.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #0d6efd;\n  --bs-link-hover-color: #0a58ca;\n  --bs-code-color: #d63384;\n  --bs-highlight-bg: #fff3cd;\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  text-align: var(--bs-body-text-align);\n  color: #414141;\n  font-family: CVS-reg,sans-serif;\n  --tw-bg-opacity: 1!important;\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgba(59,130,246,.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  box-sizing: border-box;\n  background: #602978;\n  height: 100%;\n  overflow-x: hidden;\n  position: fixed;\n  right: 0;\n  top: 57px;\n  transition: .5s;\n  z-index: 11;\n  width: 100%;\n}\n#mySidenav.nav-wrapper{\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #198754;\n  --bs-info: #0dcaf0;\n  --bs-warning: #ffc107;\n  --bs-danger: #dc3545;\n  --bs-light: #f8f9fa;\n  --bs-dark: #212529;\n  --bs-primary-rgb: 13,110,253;\n  --bs-secondary-rgb: 108,117,125;\n  --bs-success-rgb: 25,135,84;\n  --bs-info-rgb: 13,202,240;\n  --bs-warning-rgb: 255,193,7;\n  --bs-danger-rgb: 220,53,69;\n  --bs-light-rgb: 248,249,250;\n  --bs-dark-rgb: 33,37,41;\n  --bs-white-rgb: 255,255,255;\n  --bs-black-rgb: 0,0,0;\n  --bs-body-color-rgb: 33,37,41;\n  --bs-body-bg-rgb: 255,255,255;\n  --bs-font-sans-serif: system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n  --bs-gradient: linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #212529;\n  --bs-body-bg: #fff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #dee2e6;\n  --bs-border-color-translucent: rgba(0,0,0,.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #0d6efd;\n  --bs-link-hover-color: #0a58ca;\n  --bs-code-color: #d63384;\n  --bs-highlight-bg: #fff3cd;\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  text-align: var(--bs-body-text-align);\n  color: #414141;\n  font-family: CVS-reg,sans-serif;\n  --tw-bg-opacity: 1!important;\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x: ;\n  --tw-pan-y: ;\n  --tw-pinch-zoom: ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-ordinal: ;\n  --tw-slashed-zero: ;\n  --tw-numeric-figure: ;\n  --tw-numeric-spacing: ;\n  --tw-numeric-fraction: ;\n  --tw-ring-inset: ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgba(59,130,246,.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur: ;\n  --tw-brightness: ;\n  --tw-contrast: ;\n  --tw-grayscale: ;\n  --tw-hue-rotate: ;\n  --tw-invert: ;\n  --tw-saturate: ;\n  --tw-sepia: ;\n  --tw-drop-shadow: ;\n  --tw-backdrop-blur: ;\n  --tw-backdrop-brightness: ;\n  --tw-backdrop-contrast: ;\n  --tw-backdrop-grayscale: ;\n  --tw-backdrop-hue-rotate: ;\n  --tw-backdrop-invert: ;\n  --tw-backdrop-opacity: ;\n  --tw-backdrop-saturate: ;\n  --tw-backdrop-sepia: ;\n  box-sizing: border-box;\n  background: #602978;\n  height: 100%;\n  overflow-x: hidden;\n  position: fixed;\n  right: 0;\n  top: 57px;\n  transition: .5s;\n  width: 0;\n  z-index: 11;\n}\n\n#lightBulbDiv {\n  margin-top: 1%;\n  background: #fff;\n  padding: 15px;\n  border: 0.5px dashed gray;\n}\n\n#lightBulbLeftBlock {\n  width: 5%;\n  float: left;\n}\n\n#lightBulbRightBlock {\n  width: 92%;\n  float: right;\n}\n\n.nav-tabs > li.active > a,\n.nav-tabs > li.active > a:focus,\n.nav-tabs > li.active > a:hover {\n  background-color: #7d3f98;\n  border: 0 none;\n}\n\n#sessionTimeoutModalPhr {\n  color: #fff;\n  font-size: 24px !important;\n  font-family: Domaine Display !important;\n  font-weight: 700;\n}\n\n.modal-header .close {\n  margin-top: 4px;\n}\n\n.acc-modal-header .close {\n  margin-top: -42px;\n}\n\n@media (min-width: 992px) {\n  .acc-modal-header .close {\n    margin-top: -30px;\n  }\n}\n\n.usefulInfo-block {\n  padding: 5px;\n}\n\n.saveAndContinue {\n  width: 205px !important;\n}\n\n.border-bottom {\n  border: 5px solid #eee !important;\n}\n\n.espanolpage {\n  background-color: #fff !important;\n  border: 1px solid #ccc;\n  box-shadow: 0 2px 2px -1px #ccc;\n}\n\n.coverageBenefits_bg {\n  background-color: #eee !important;\n  padding-top: 10px;\n}\n\n.navbar-default .navbar-nav > li > a:active,\n.navbar-default .navbar-nav > li > a:focus {\n  text-decoration: underline !important;\n}\n\n.nav-mobile-list .menu-button {\n  display: none !important;\n}\n\n.newDiscountThumb {\n  border-radius: 0 !important;\n}\n\n.newDiscountThumb .cardimagecaption {\n  padding-bottom: 12px;\n}\n\n.newDiscountThumb .cardimagecaptionJoint {\n  opacity: 0.8;\n  padding-bottom: 12px;\n}\n\n.padLeftClear {\n  padding-left: 15px;\n}\n\n.padRightClear {\n  padding-right: 15px;\n}\n\n.linkActiveUnderline {\n  text-decoration: underline !important;\n}\n\n.linkDeactiveUnderline {\n  text-decoration: none !important;\n}\n\n.nav-tabs {\n  padding: 10px;\n  position: absolute;\n  z-index: 10;\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .nav-tabs {\n    position: relative;\n    display: block !important;\n  }\n\n  .global-overlay {\n    display: none;\n  }\n}\n\nbody,\nhtml {\n  font-family: Open Sans !important;\n  font-weight: 400;\n  color: #414141;\n}\n\nbody {\n  background: #fff;\n  overflow-x: hidden;\n  font-size: 16px;\n  padding-right: 0 !important;\n  -ms-overflow-style: scrollbar;\n}\n\nli,\nul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n\n.claimsNarrowDown .padTB16 {\n  background: #7d3f98;\n  padding: 12px 0 !important;\n}\n\na,\na:visited {\n  color: #7d3f98;\n}\n\na,\na:focus {\n  text-decoration: none;\n}\n\na:focus {\n  color: #076f86;\n}\n\na:active {\n  color: #d20962 !important;\n  text-decoration: none;\n}\n\na:focus,\na:hover {\n  color: #7d3f98;\n  text-decoration: underline;\n}\n\nsection a {\n  font-weight: 400;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: Open Sans !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-weight: 400 !important;\n  margin: 0 !important;\n}\n\nh1 {\n  font-size: 1.5em;\n}\n\nh2 {\n  font-size: 1.06em;\n}\n\nh3 {\n  font-size: 0.875em;\n}\n\nsmall {\n  font-size: 0.68em;\n}\n\nlabel,\np,\nspan {\n  font-size: 16px;\n  color: #414141;\n  font-weight: 400;\n}\n\nimg {\n  text-indent: -9999px;\n  max-width: 100% !important;\n}\n\nsection {\n  background: #eee;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  opacity: 0;\n}\n\ninput[type=\"radio\"] {\n  vertical-align: top;\n}\n\naddress {\n  display: inline-block;\n}\n\nlegend {\n  margin-bottom: 12px;\n  border-bottom: 0 none;\n}\n\ntextarea {\n  overflow: auto;\n  background-color: #eee;\n  width: 100%;\n  height: 150px;\n}\n\nsup {\n  color: #7d3798;\n  font-size: 14px !important;\n  padding: 0;\n  margin: 0;\n  position: relative;\n  top: -0.5em !important;\n}\n\nul.bulletType_disc,\nul.bulletType_disc li {\n  list-style: disc outside none;\n}\n\nul.bulletType_check li:before {\n  content: \"\\2713\\0020\";\n}\n\nul.orientation_vertical {\n  padding-left: 40px;\n}\n\nul.bulletType_decimal,\nul.bulletType_decimal li {\n  list-style: decimal outside none;\n}\n\nul.menu-list li a {\n  margin-left: 10px;\n}\n\n.aet-sponser-logo {\n  display: inline !important;\n}\n\n.menu-overlay {\n  background: #000;\n  position: absolute;\n  top: 115px;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  opacity: 0.5;\n  z-index: 1000;\n}\n\n.menu-list {\n  position: absolute;\n  width: 360px;\n  background: #eee none repeat scroll 0 0;\n  z-index: 100000;\n  border: 1px solid #ccc;\n  top: 0;\n}\n\nul.menu-list li a span {\n  font-size: 18px;\n}\n\nul.menu-list li {\n  margin: 0 4px 4px;\n  padding: 10px !important;\n  background: #fff none repeat scroll 0 0;\n  position: relative;\n  width: 98%;\n}\n\nul.menu-list li.home-mobile-list,\nul.menu-list li.home-mobile-list ul li {\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 100%;\n}\n\nul.menu-list li.home-mobile-list ul li {\n  padding: 8px 5px !important;\n}\n\n.menu-list li.inactive {\n  padding: 9px 10px !important;\n  background: #eee none repeat scroll 0 0;\n  margin: 0;\n}\n\n.menu-list li a img.left-img {\n  width: 80%;\n}\n\nul.menu-list li.home-mobile-list ul li .badge {\n  font-size: 14px;\n  padding: 2px 10px;\n  margin-top: -12px;\n}\n\n.menu-list li a.blueActive,\n.menu-list li a.canbActive,\n.menu-list li a.greenActive,\n.menu-list li a.purpleActive,\n.menu-list li a.tealActive {\n  box-shadow: 0 0 5px 0 #ccc;\n  font-weight: 700;\n}\n\n.menu-list-txt {\n  margin: 8px 0 0 10px;\n}\n\n.nested-list a {\n  display: none;\n  margin-left: 30px;\n  padding: 10px !important;\n}\n\n.purpuleShade {\n  background-color: transparent;\n}\n\n.second-navigation {\n  background: #fff;\n  border-bottom: 1px solid #ccc;\n  position: relative;\n}\n\n.second-navigation a,\n.second-navigation p {\n  color: #596368;\n  display: block;\n  padding: 15px 25px;\n  border-bottom: 3px solid transparent;\n  border-right: 1px solid #ccc;\n  float: none;\n  font-size: 20px;\n  background-color: #e0e0e0;\n  border: 1px solid #f5f5f5 !important;\n  margin: 1%;\n}\n\n.second-navigation a.canbLevel {\n  font-weight: 700;\n  color: #2f3338;\n}\n\n.second-navigation a.canbLevel {\n  background-color: #7d3f98;\n  border: 3px solid #fff;\n  border-bottom: none !important;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation a.canbLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #7d3f98;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.second-navigation a.messageLevel {\n  font-weight: 700;\n  color: #2f3338;\n}\n\n.second-navigation a.messageLevel {\n  background-color: #526f83;\n  border: 3px solid #fff;\n  border-bottom: none !important;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation a.messageLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #526f83;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.second-navigation a.blueLevel {\n  background-color: #0d8ba7;\n  border: 3px solid #fff;\n  border-bottom: none !important;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation a.blueLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #0d8ba7;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.second-navigation a.purpleLevel {\n  background-color: #7d3f98;\n  border: 3px solid #fff;\n  border-bottom: none !important;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation a.purpleLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #7d3f98;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.second-navigation a.greenLevel {\n  background-color: #4e7d2a;\n  border: 3px solid #fff;\n  border-bottom: none !important;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation a.greenLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #4e7d2a;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.second-navigation a.tealLevel {\n  background-color: #00a783;\n  border: 3px solid #fff;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation a.tealLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #00a783;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.second-navigation p.oliveGreenLevel {\n  background-color: #4e7d2a;\n  border: 3px solid #fff;\n  border-bottom: none !important;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation p.oliveGreenLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #4e7d2a;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.second-navigation p.teal-greenLevel {\n  background-color: #00a783;\n  border: 3px solid #fff;\n  border-bottom: none !important;\n  color: #fff !important;\n  position: relative;\n}\n\n.second-navigation p.teal-greenLevel:after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  width: 0;\n  height: 0;\n  border-top: 10px solid #00a783;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n}\n\n.left-scrollarrow,\n.right-scrollarrow {\n  background-image: url(https://member.aetna.com/secure/member/images/claimsArrow_left.png);\n  background-repeat: no-repeat;\n  background-position: 50%;\n  width: 14px;\n  height: 40px;\n  background-color: #fff;\n  opacity: 0.9;\n  display: inline-block;\n  padding: 25px;\n  position: absolute;\n  top: -58px;\n  visibility: hidden;\n}\n\n.scroll-arrowsLR {\n  position: relative;\n  display: none;\n}\n\n.right-scrollarrow {\n  background-image: url(https://member.aetna.com/secure/member/images/claimsArrow.png);\n  right: 0;\n}\n\n.sec-level-nav {\n  padding: 10px 20px;\n  display: inline-block;\n  border-left: 0 none;\n  border-right: 1px solid #ccc;\n}\n\n.sec-level-nav:first-child {\n  border-left: 1px solid #ccc;\n}\n\n.borderLeftGrey {\n  border-left: 1px solid #ccc !important;\n}\n\n.bH_pleat_bg_color {\n  background-color: #7d3f98;\n}\n\n.menu-txt {\n  font-size: 20px;\n  float: right;\n  color: #076f86;\n  margin: 5px 0;\n  text-align: right;\n  width: 25% !important;\n}\n\n.menu-txt:focus {\n  outline: none !important;\n  box-shadow: 0 0 10px #719ece;\n}\n\n.line-seperator {\n  background: url(https://member.aetna.com/secure/member/images/header-sep.png) no-repeat 0 0;\n  height: 30px;\n  width: 2px;\n  position: absolute;\n  left: -25px;\n  top: 12px;\n}\n\n.close-menu {\n  background: url(https://member.aetna.com/secure/member/images/close.png) no-repeat 0 0;\n  display: inline-block;\n  height: 34px;\n  width: 34px;\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n}\n\n.logout-menu {\n  background: url(https://member.aetna.com/secure/member/images/homeicons/logout_icon_mobile_transparent.png)\n    no-repeat 0 0;\n  display: inline-block;\n  height: 46px;\n  width: 46px !important;\n  position: absolute !important;\n  right: 10px;\n  top: 5px;\n  display: none;\n}\n\n.home-down-arrow,\n.home-up-arrow {\n  background: url(https://member.aetna.com/secure/member/images/homeicons/home-list-down.png) no-repeat 0 0;\n  display: none;\n  height: 9px;\n  width: 15px;\n}\n\n.home-down-arrow.home-up-arrow {\n  background: url(https://member.aetna.com/secure/member/images/homeicons/home-list-up.png) no-repeat 0 0;\n  display: none;\n}\n\n.menu-mobile-icon {\n  width: 78%;\n  display: none !important;\n}\n\na.blueActive,\na.canbActive,\na.greenActive,\na.purpleActive,\na.tealActive,\nul li.blueActive a span,\nul li.canbActive a span,\nul li.greenActive a span,\nul li.purpleActive a span,\nul li.tealActive a span {\n  color: #2f3338;\n}\n\n.blueActive,\n.canbActive,\n.greenActive,\n.purpleActive,\n.tealActive {\n  border-color: #d20962;\n  border-style: solid;\n  border-width: 0 0 0 5px;\n}\n\n.blueActive {\n  border-color: #0d8ba7;\n}\n\n.purpleActive {\n  border-color: #7d3f98;\n}\n\n.greenActive {\n  border-color: #00a783;\n}\n\nh1.greenActive {\n  border-color: transparent;\n}\n\n.tealActive {\n  border-color: #5e9732;\n}\n\nsection {\n  background-color: #fff;\n}\n\n[role=\"button\"] {\n  display: block;\n}\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: not-allowed;\n  background: #b18cc1;\n  color: #414141;\n}\n\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  -moz-opacity: 0.5;\n  -khtml-opacity: 0.5;\n}\n\n.aet-content-fluid {\n  max-width: 1141px;\n  margin: 0 auto;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.aet-wrapper {\n  position: relative;\n}\n\n.aet-template {\n  margin-bottom: 0;\n}\n\n.aet-main-container {\n  background-color: #fff;\n}\n\n.aet-nav-header {\n  padding-bottom: 2px;\n}\n\n.panel-title a:hover {\n  text-decoration: none;\n}\n\n.container-fluid {\n  padding: 0;\n}\n\n.container1 {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.noborder {\n  border: 0 !important;\n}\n\n.topMrgn30 {\n  margin-top: 30px;\n}\n\n.mrgnR15 {\n  margin-right: 15px;\n}\n\n.image-circle {\n  border-radius: 50%;\n}\n\n.rightborder {\n  border-right: 1px solid #ccc !important;\n}\n\n.white-section {\n  background-color: #fff !important;\n}\n\n.top-mrgn10 {\n  margin-top: 10px;\n}\n\n.badge {\n  text-align: center;\n  word-break: break-word;\n  vertical-align: middle;\n  white-space: normal;\n  padding: 3px 10px;\n  margin-top: -20px;\n  margin-left: 5px;\n  background: #b18cc0;\n  border-radius: 6px;\n}\n\n.block {\n  display: block;\n}\n\n.top-border {\n  border-top: 1px solid #ccc;\n}\n\n.separator {\n  color: #d0d1d3;\n}\n\n.mobile,\n.mobile-view .desktop,\n.tablet,\n.tablet-view .desktop {\n  display: none;\n}\n\n.disp-mob,\n.mobile-view .mobile,\n.tablet-view .tablet {\n  display: block;\n}\n\n@media (max-width: 992px) {\n  .mobilehide {\n    display: none !important;\n  }\n}\n\n.curser {\n  cursor: pointer;\n}\n\n.fsize85P {\n  font-size: 82%;\n}\n\n.fsize120p {\n  font-size: 120%;\n}\n\n.wd100P {\n  width: 100%;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.pad0,\n.paddingZero {\n  padding: 0;\n}\n\n.padR45 {\n  padding-right: 45px;\n}\n\n.padR5 {\n  padding-right: 5px;\n}\n\n.padL35 {\n  padding-left: 35px;\n}\n\n.padL25 {\n  padding-left: 25px;\n}\n\n.padL5 {\n  padding-left: 5px;\n}\n\nspan a div.padL5 {\n  display: inline-block;\n}\n\n.marR10 {\n  margin-right: 10px;\n}\n\n.marT15 {\n  margin-top: 15px;\n}\n\n.marT10 {\n  margin-top: 10px;\n}\n\n.pad10 {\n  padding: 10px;\n}\n\n.padT5 {\n  padding-top: 5px;\n}\n\n.padB5 {\n  padding-bottom: 5px;\n}\n\n.fontstyle2 {\n  font-size: 32px;\n}\n\n.fontstyle3 {\n  font-size: 14px;\n}\n\n.fontsize1 {\n  font-size: 16px !important;\n}\n\n.fontstyle16 {\n  font-size: 16px;\n}\n\n.left-pad0 {\n  padding-left: 0;\n}\n\n.right-pad0 {\n  padding-right: 0;\n}\n\n.mar0 {\n  margin: 0;\n}\n\n.padR0px {\n  padding-right: 0;\n}\n\n.padBottom0 {\n  padding-bottom: 0 !important;\n}\n\n.mrgnLeft {\n  margin-left: 10%;\n}\n\n.mrgnLeft35 {\n  margin-left: 35px;\n}\n\n.mrgnzero {\n  margin: 0 !important;\n}\n\n.marT10px {\n  margin-top: 10px;\n}\n\n.padB20 {\n  padding-bottom: 20px;\n}\n\n.marR15 {\n  margin-right: 15px;\n}\n\n.marL15 {\n  margin-left: 15px;\n}\n\n.desktop-only {\n  display: none;\n}\n\n.inline-block {\n  display: inline-block !important;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.disp-mob {\n  display: none !important;\n}\n\n.disp-desktop {\n  display: block !important;\n}\n\n@media (max-width: 991px) {\n  .disp-desktop {\n    display: none !important;\n  }\n\n  .mrgnLeft {\n    margin-left: 0;\n  }\n\n  .bottom-border,\n  .bottom-border-idcard {\n    border-bottom: 1px solid #ccc !important;\n  }\n}\n\n.mrgn20 {\n  margin-top: 20px;\n}\n\n.padL110 {\n  padding-left: 110px;\n}\n\n.disp-row {\n  display: table-row;\n}\n\n.tableCell {\n  display: table-cell;\n}\n\n.error {\n  color: #a94442;\n}\n\n.err-txt {\n  text-align: center;\n  width: 100%;\n  display: inline-block;\n}\n\n.positionRelative {\n  position: relative;\n}\n\n.left-txt {\n  text-align: left !important;\n  margin: 0;\n}\n\n.anchor {\n  color: #7d3f98;\n}\n\n.important {\n  color: #ef4234;\n}\n\n.no-resize {\n  resize: none;\n}\n\n.mandatory {\n  color: #d20962;\n}\n\n.btn-submit button {\n  border: none;\n}\n\n.white {\n  background-color: #fff;\n}\n\n.redShade {\n  background-color: #d20962;\n}\n\n.greenShade {\n  background-color: #1d7564;\n}\n\n.purpuleShade {\n  background-color: #7d3f98;\n}\n\n.lightBlueShade {\n  background-color: #076f86;\n}\n\n.blueShade {\n  background-color: #4b65ae;\n}\n\n.greyShade {\n  background-color: #eee;\n}\n\n.depperGrey {\n  background-color: #888;\n}\n\n.close,\n.close:focus,\n.close:hover {\n  opacity: 1;\n}\n\n.underline {\n  border-bottom: 1px solid #076f86;\n}\n\n.paddlr30 {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n\n.pad20 {\n  padding: 20px;\n}\n\n.topMrgn50 {\n  margin-top: 50px;\n}\n\n.marBot60 {\n  margin-bottom: 60px;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.heads {\n  color: #7d3f98;\n  font-size: 1.25em;\n}\n\n.checkboxbg {\n  margin-top: 1px;\n}\n\n.checkboxbg label {\n  margin: 0;\n}\n\n.padR0 {\n  padding-right: 0;\n}\n\n.marT8 {\n  margin-top: 8px;\n}\n\n.marB0 {\n  margin-bottom: 0;\n}\n\n.marB15 {\n  margin-bottom: 15px;\n}\n\n.padT8 {\n  padding-top: 8px;\n}\n\n.padL0 {\n  padding-left: 0;\n}\n\n.padL0Imp {\n  padding-left: 0 !important;\n}\n\n.padL15 {\n  padding-left: 15px;\n}\n\n.normalFont {\n  font-weight: 400;\n}\n\n.italics {\n  font-style: italic;\n}\n\n.normalfont {\n  font-weight: 400;\n}\n\n.font-20 {\n  font-size: 20px;\n}\n\n.font14 {\n  font-size: 14px;\n}\n\n.padL10 {\n  padding-left: 10px;\n}\n\n.font18 {\n  font-size: 18px;\n}\n\n.zeroMrgn {\n  margin: 0 !important;\n}\n\n.white-bg {\n  background: #fff;\n}\n\n.clear {\n  clear: both;\n}\n\n.pad00 {\n  padding: 0;\n}\n\n.hide-ac {\n  font-size: 0;\n}\n\n.padT15 {\n  padding-top: 15px;\n}\n\n.padB15 {\n  padding-bottom: 15px;\n}\n\n.padB11 {\n  padding-bottom: 11px;\n}\n\n.padR15 {\n  padding-right: 15px;\n}\n\n.pad15 {\n  padding: 15px;\n}\n\n.padR20 {\n  padding: 20px;\n}\n\n.marTB10 {\n  margin: 10px 0;\n}\n\n.marTB14 {\n  margin: 14px 0;\n}\n\n.marB20 {\n  margin-bottom: 20px;\n}\n\nul li a span {\n  color: #076f86;\n  font-size: 15px;\n}\n\n.zeromrgn {\n  margin: 0 !important;\n}\n\n.padzero {\n  padding: 0;\n}\n\n.no-border {\n  border: 0;\n}\n\n.bottom-border-idcard {\n  border-bottom: 1px solid #ccc !important;\n}\n\n.no-border {\n  border: 0 !important;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.pos-a {\n  position: absolute;\n}\n\n.fixedScroller {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  z-index: 999;\n  display: none;\n}\n\n.fixedScroller p.pad15 {\n  padding: 5px 0;\n}\n\n.aet-cont-hdrtxt img {\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n\n.mar0auto {\n  margin: 0 auto;\n}\n\n.opacity_layer {\n  opacity: 0.9;\n}\n\n.fixedScroller.end .downPointer {\n  display: none;\n  opacity: 0;\n}\n\n.upPointer {\n  display: none;\n}\n\n#aet-footer.mar0 {\n  margin-bottom: 0;\n}\n\n.entireWarpper.shift .menu-toggle-btn .icon-bar {\n  position: relative;\n  transition: transform 0.5s;\n  -moz-transition: transform 0.5s;\n  -webkit-transition: transform 0.5s;\n  -ms-transition: transform 0.5s;\n  -o-transition: transform 0.5s;\n}\n\n.entireWarpper.shift .menu-toggle-btn .icon-bar:nth-child(2) {\n  transform: rotate(35deg);\n  -moz-transform: rotate(35deg);\n  -webkit-transform: rotate(35deg);\n  -ms-transform: rotate(35deg);\n  -o-transform: rotate(35deg);\n  top: 5px;\n}\n\n.entireWarpper.shift .menu-toggle-btn .icon-bar:nth-child(3) {\n  display: none;\n}\n\n.entireWarpper.shift .menu-toggle-btn .icon-bar:nth-child(4) {\n  transform: rotate(-35deg);\n  -moz-transform: rotate(-35deg);\n  -webkit-transform: rotate(-35deg);\n  -ms-transform: rotate(-35deg);\n  -o-transform: rotate(-35deg);\n  top: -3px;\n}\n\n#skip-to-content {\n  display: block !important;\n}\n\n#toFocus a {\n  position: absolute;\n  top: -100px;\n  left: 0;\n}\n\n#skip-to-content a {\n  padding: 6px 3px;\n  position: absolute;\n  top: -40px;\n  left: 2px;\n  color: #fff !important;\n  border-right: 1px solid #fff;\n  border-bottom: 1px solid #fff;\n  border-bottom-right-radius: 8px;\n  background: #526783;\n  transition: top 1s ease-out, background 1s linear;\n  z-index: 100;\n}\n\n#skip-to-content a:active,\n#skip-to-content a:focus {\n  position: absolute;\n  left: 2px;\n  top: 0;\n  color: #fff;\n  background: #526783;\n  outline: 0;\n  transition: top 0.1s ease-in, background 0.5s linear;\n}\n\n\n\n.aet-sponser-logo {\n  display: inline;\n}\n\n.icon-block-purple img {\n  background: #7d3f98;\n  padding: 5px 6px;\n  border-radius: 20px;\n}\n\n.sessionTimeout h1 {\n  font-size: 24px;\n}\n\n.sessionTimeout .modal-body span,\n.yourAlert .modal-body h2 {\n  font-size: 20px;\n}\n\n.sessionTimeout .modal-footer button,\n.yourAlert .modal-footer button {\n  margin-right: 30px;\n  margin-bottom: 20px;\n}\n\n.yourAlert .checkboxbg {\n  margin-top: 25px;\n}\n\n#yourAlert {\n  margin-top: 12%;\n}\n\n.menu-button .sr-only {\n  font-size: 24px;\n}\n\n@media (min-width: 991px) {\n  .margin-adjust-smc {\n    margin-left: 50px !important;\n  }\n}\n\n.attachmentAdjust {\n  padding: 15px;\n}\n\n@media (max-width: 350px) {\n  .mycol {\n    width: 200px !important;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n\n  .navbar-header {\n    width: 100%;\n  }\n\n  .col-sm-3.pad0.col-xs-12.navbar-header {\n    margin: 0;\n  }\n\n  .nav-mobile-list li {\n    margin-right: 10px;\n  }\n\n  .nav-list-blk {\n    color: #076f86;\n    display: none !important;\n    font-size: 14px;\n  }\n\n  .nav-mobile-list li {\n    float: left;\n    margin-right: 24px;\n  }\n\n  .nav-mobile-list li:last-child {\n    margin-right: 0;\n  }\n\n  .nav-mobile-list {\n    display: block;\n    position: absolute;\n    right: 10px;\n    top: 20px;\n  }\n\n  .nav-mobile-username {\n    display: block !important;\n    position: absolute;\n  }\n\n  .navbar-collapse,\n  .navbar-collapse.collapse {\n    display: none !important;\n  }\n\n  .navbar {\n    background: #fff;\n    margin-bottom: 0;\n    border: 0 none !important;\n    padding: 20px 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .psImageWidth {\n    width: 25% !important;\n  }\n\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n}\n\n.aet-sponser-logo {\n  display: inline;\n}\n\n@media screen and (min-width: 768px) {\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n}\n\n@media (max-width: 991px) {\n  .nav-mobile-list {\n    display: block;\n    position: absolute;\n    right: 10px;\n    top: 15px;\n  }\n\n  .nav-mobile-username {\n    display: block !important;\n    position: absolute;\n    margin: 10px 0 0;\n  }\n\n  .nav-button {\n    display: block;\n    position: absolute;\n    left: 0;\n    top: 23px;\n  }\n\n  .aet-sponser-logo,\n  .navbar-collapse,\n  .navbar-collapse.collapse {\n    display: none !important;\n  }\n\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 991px) {\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n\n  .aet-header .container {\n    padding: 0;\n    width: 100%;\n  }\n\n  .aet-sponser-logo {\n    display: none !important;\n  }\n\n  .aet-logo img,\n  .aet-sponser-logo,\n  .navigator-logos a {\n    width: 150px;\n  }\n\n  .navbar-default .navbar-nav > li > a img {\n    display: none;\n  }\n\n  .show-icons .navbar-default .navbar-nav > li > a img {\n    display: block;\n    margin-left: 12px;\n  }\n\n  .show-icons .navbar-collapse {\n    top: 0;\n  }\n\n  .navbar-collapse {\n    right: 50px;\n  }\n\n  .navbar-default .navbar-nav > li > a.home-util,\n  .navbar-default .navbar-nav > li > a:hover.home-util {\n    margin-right: 0;\n  }\n\n  .navbar-nav > li {\n    margin-right: 5px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .aet-sponser-logo {\n    width: 150px;\n  }\n\n  .navbar-default .navbar-nav > li > a {\n    padding: 0 5px;\n  }\n\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .navbar-default .navbar-nav > li > a {\n    padding: 0 10px;\n  }\n\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n}\n\n@media (min-width: 992px) {\n  .aet-sponser-logo {\n    display: inline-block !important;\n  }\n\n  .navigator-logos a {\n    width: 100px;\n  }\n\n  .nav-button {\n    display: none;\n  }\n\n  .navbar-collapse,\n  .navbar-collapse.collapse {\n    display: block;\n  }\n\n  .menu-list {\n    top: 0;\n    right: auto;\n    width: 250px;\n  }\n}\n\n@media (min-width: 992px) {\n  .aet-sponser-logo {\n    display: inline-block !important;\n  }\n\n  .nav-button,\n  .nav-mobile-list,\n  .nav-mobile-username {\n    display: none !important;\n  }\n\n  .navbar-collapse,\n  .navbar-collapse.collapse {\n    display: block !important;\n  }\n\n  .navbar-collapse {\n    top: 8px;\n  }\n\n  .navbar-default .navbar-nav > li > a img {\n    display: none;\n  }\n\n  .navbar-default .navbar-nav > li > a {\n    padding: 0 6px;\n  }\n\n  .navbar-default .navbar-nav > li > a img {\n    display: block;\n    margin-left: 8px;\n  }\n}\n\n@media (max-width: 991px) {\n  .navbar-default .navbar-nav > li > a.home-util,\n  .navbar-default .navbar-nav > li > a.home-util:hover {\n    margin-top: 2px !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-default .navbar-nav > li > a.home-util,\n  .navbar-default .navbar-nav > li > a.home-util:hover {\n    margin-top: -4px !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navigator-logos .aet-logo .aet-sponser-logo,\n  .navigator-logos .aet-sponser-logo {\n    height: 40px;\n    width: 240px;\n  }\n\n  .navbar-default .navbar-nav > li > a img {\n    display: inline-block;\n    margin-left: 0;\n  }\n\n  .navbar-default .navbar-nav > li > a {\n    padding: 0 8px;\n    border-right: 1px solid #076f86;\n  }\n\n  .navbar-collapse {\n    top: 28px;\n  }\n}\n\n@media (-ms-high-contrast: none), screen and (-ms-high-contrast: active) {\n  .navbar-collapse {\n    top: 5px !important;\n  }\n}\n\n.select-box .dropdown-toggle.btn-default,\n.select-box .dropdown-toggle.btn-default:focus {\n  background-color: #fff;\n}\n\n.select-box .btn {\n  width: 100%;\n  text-align: left;\n  height: 35px;\n  border-radius: none;\n  border-top: 0;\n  border-left: 0;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-weight: 700;\n}\n\n.caret-image {\n  position: absolute;\n  width: 40px;\n  border-top: 0;\n  border-left: 0;\n  font-weight: 700;\n  background-image: url(https://member.aetna.com/secure/member/images/selectbox-select.png);\n  background-repeat: no-repeat;\n  background-position: 100% 0;\n  background-color: #eee;\n  height: 35px;\n  border: 0 none;\n  border-radius: 0;\n  box-shadow: 0 1px #c5c5c5;\n  top: 0;\n  right: 0;\n  margin: 0;\n}\n\n@media (max-width: 991px) {\n  .second-navigation a.sec-level-nav {\n    width: auto;\n    border: 3px solid #fff;\n  }\n\n  .second-navigation1 .container1,\n  .second-navigation .container {\n    overflow-x: auto;\n    white-space: nowrap;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 500px) {\n  .second-navigation a.sec-level-nav {\n    width: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .second-navigation,\n  .second-navigation1 {\n    width: 100%;\n  }\n\n  .second-navigation1 .container1,\n  .second-navigation .container {\n    margin: 0;\n    width: auto;\n  }\n\n  .scroll-arrowsLR {\n    display: block;\n    margin-top: -6px;\n  }\n}\n\n.select-box .option li:hover {\n  background-color: #7d3f98;\n  cursor: pointer;\n}\n\n.border-top-color-Sponsor-Links {\n  border-top: 6px solid #586d7e;\n  background-color: #eee;\n  padding-top: 2%;\n  margin-top: 2%;\n}\n\n.background-Third-Party-Links {\n  background-color: #eee;\n  padding-left: 2%;\n  padding-bottom: 1%;\n  margin-top: 20px;\n}\n\n.pslinks {\n  font-weight: 700;\n}\n\n.progress-bar {\n  background-color: #7d3f98;\n}\n\n.balanceBoxLinks {\n  background: #7d3f98;\n}\n\n.sponsor_links a img {\n  padding-left: 6px;\n}\n\n.wrap_sponsor_links {\n  word-wrap: break-word !important;\n}\n\n.background-Third-Party-Links:first-child {\n  box-shadow: none;\n}\n\n.close-menu:focus {\n  outline: none !important;\n}\n\n.dentalInfogram,\n.medicalInfogram {\n  border: 1px solid #ccc;\n  border-top: 3px solid #7d3f98;\n  background: #fff;\n}\n\n.topHeadingBackGround {\n  background: #7d3f98;\n  margin-top: 30px;\n}\n\n.tableFormat .dataGridTableHeader th,\n.tableFormat tbody tr td {\n  padding: 15px;\n}\n\n.tableFormat tbody tr td {\n  border-bottom: 1px solid #ccc;\n}\n\n.tableFormat tbody tr.evenRow,\n.tableFormat tbody tr.oddRow {\n  background-color: #fff;\n}\n\ntable.tableFormat {\n  border-collapse: separate;\n  border: 1px solid #ccc;\n  width: 100%;\n}\n\n.tableFormat .tableCaption {\n  height: 0;\n  padding: 0;\n  color: #526f83;\n}\n\n.tableFormat .dataGridTableHeader {\n  height: 65px;\n  width: 100%;\n  background-color: #7d3f98;\n  color: #fff;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.tableFormat .dataGridTableContant {\n  background: #fff;\n  margin-bottom: 15px;\n}\n\n.tableFormat .dataGridTableContant tr td:last {\n  border-right: 1px solid #ccc;\n}\n\n.tableFormat thead .billhead a {\n  width: 108px;\n}\n\n.tableFormat thead .reshead a {\n  width: 165px;\n}\n\n.tableIncentive {\n  margin-left: 20px;\n}\n\n.tableBenefits caption,\n.tableIncentive caption {\n  color: transparent;\n  height: 0;\n  padding: 0;\n}\n\n.tableIncentive .dataGridTableHeader th,\n.tableIncentive tbody tr td {\n  padding: 20px 190px 20px 20px;\n}\n\n.tableIncentive tbody tr {\n  background: #eee;\n  border-bottom: 10px solid #fff;\n}\n\n.tableBenefits thead th {\n  width: 21%;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  background: #eee;\n}\n\n.tableBenefits {\n  width: 100%;\n}\n\n@media (max-width: 1200px) {\n  .tableIncentive .dataGridTableHeader th,\n  .tableIncentive tbody tr td {\n    padding: 20px 130px 20px 20px;\n  }\n\n  select {\n    width: 170px;\n  }\n}\n\n@media (max-width: 991px) {\n  select {\n    width: 97%;\n  }\n\n  .tableFormat.responsiveCustomTable td.deviceViewGridCol,\n  .tableFormat.responsiveCustomTable th.deviceViewGridCol {\n    display: none !important;\n  }\n\n  .tableIncentive .dataGridTableHeader th,\n  .tableIncentive tbody tr td {\n    padding: 20px 25px 20px 20px;\n  }\n\n  .tableFormat thead .billhead a,\n  .tableFormat thead .reshead a {\n    width: auto;\n  }\n\n  .new_claims_arrow {\n    margin-top: 3px !important;\n    margin-left: 5px !important;\n  }\n\n  .tableBenefits thead {\n    display: none;\n  }\n\n  .tableBenefits td,\n  .tableBenefits th {\n    display: block !important;\n  }\n\n  .tableBenefits tr {\n    border-top: 1px solid #ccc;\n  }\n\n  .panel.panel-default .tableBenefits div,\n  .panel.panel-default .tableBenefits span {\n    font-size: 16px;\n  }\n\n  .idCardWidth {\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n\n  .padding-top-id {\n    padding: 10px;\n  }\n\n  .noPull {\n    float: right !important;\n  }\n}\n\n@media (min-width: 767px) {\n  #billAmtCol {\n    width: 136px;\n  }\n\n  #providerCol {\n    width: 180px;\n  }\n\n  #planPaidCol {\n    width: 115px;\n  }\n\n  #youResponsbilityCol {\n    width: 185px;\n  }\n}\n\n@media (max-width: 767px) {\n  #memberCol {\n    font-size: 12px;\n    width: 66px;\n    padding-left: 0;\n  }\n\n  #providerCol {\n    font-size: 12px;\n    padding-left: 7px;\n    width: 91px;\n  }\n\n  #memberData {\n    padding-left: 0;\n  }\n\n  #providerData {\n    padding-left: 7px;\n  }\n\n  #dateOfServiceCol {\n    width: 65px;\n  }\n\n  #dateOfServiceCol a span,\n  #youResponsbilityCol a span {\n    font-size: 12px;\n  }\n\n  .tableFormat.responsiveCustomTable td,\n  .tableFormat.responsiveCustomTable th {\n    padding: 15px 2px;\n    font-size: 12px;\n  }\n\n  .tableFormat.responsiveCustomTable th {\n    padding: 15px 6px;\n    font-size: 12px;\n  }\n\n  .tableFormat.responsiveCustomTable td span {\n    padding: 15px 0;\n    font-size: 12px;\n  }\n\n  .tableIncentive .dataGridTableHeader th,\n  .tableIncentive tbody tr td {\n    padding: 20px 0 20px 10px;\n  }\n}\n\n@media (max-width: 420px) {\n  .tableIncentive .dataGridTableHeader th,\n  .tableIncentive tbody tr td {\n    padding: 20px 2px;\n  }\n\n  .tableIncentive {\n    margin-left: 0;\n  }\n\n  .tableIncentive .dataGridTableHeader th {\n    padding-bottom: 5px;\n  }\n}\n\n.claimsDataGridText {\n  font-weight: 700;\n}\n\n:root .pricarephy .panel-group .panel-heading a .plus_minus,\n_:-ms-fullscreen {\n  padding: 0 7px;\n}\n\n.floatMeLeft {\n  float: left;\n}\n\n.aetLogoMargin {\n  margin-left: 0;\n}\n\n.padding-top-id {\n  padding-top: 2%;\n}\n\n.idCardMargin {\n  margin-left: 10px;\n}\n\n.idCardMargin:after {\n  content: \"\\a\";\n  white-space: pre;\n}\n\n.noPull {\n  float: none !important;\n}\n\n.carotSpace {\n  padding-left: 6px;\n}\n\n@media (min-width: 992px) and (max-width: 1200px) {\n  .container,\n  .container1 {\n    width: auto !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .second-navigation a,\n  .second-navigation p {\n    margin: 3%;\n  }\n}\n\n.global-overlay {\n  height: 100%;\n  width: 0;\n  position: fixed;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  background-color: #646464;\n  background-color: hsla(0, 0%, 39%, 0.9);\n  overflow-x: hidden;\n  transition: 0.5s;\n}\n\n.global-overlay-content {\n  position: relative;\n  top: 25%;\n  width: 100%;\n  text-align: center;\n  margin-top: 30px;\n}\n\n.global-overlay a {\n  padding: 8px;\n  text-decoration: none;\n  font-size: 36px;\n  color: #818181;\n  display: block;\n  transition: 0.3s;\n}\n\n.global-overlay a:focus,\n.global-overlay a:hover {\n  color: #f1f1f1;\n}\n\n.global-overlay .overlay-closebtn {\n  position: absolute;\n  top: 20px;\n  right: 45px;\n  font-size: 60px;\n}\n\n@media screen and (max-height: 450px) {\n  .global-overlay a {\n    font-size: 20px;\n  }\n\n  .global-overlay .overlay-closebtn {\n    font-size: 40px;\n    top: 15px;\n    right: 35px;\n  }\n}\n\n.redErr {\n  color: #d20962 !important;\n}\n\n.navigator-logos {\n  width: 100%;\n  margin-top: 15px;\n  margin-left: 15px;\n}\n\n@media (min-width: 1295px) {\n  .topChromeLogo {\n    width: 1300px !important;\n  }\n}\n\n.topPositionCalIcon {\n  top: 30% !important;\n}\n\n@media (max-width: 992px) {\n  .nav > li > a:focus,\n  .nav > li > a:hover {\n    text-decoration: none;\n    background-color: transparent;\n  }\n}\n\n.innerListFAQ {\n  padding-left: 50px !important;\n}\n\n.eobBtn {\n  white-space: normal !important;\n}\n\n.tabOpen {\n  margin-left: 5%;\n  display: none;\n  width: 60%;\n  background-color: #0d8ba7;\n  font-weight: 800;\n  padding: 4px;\n}\n\n.tabOpenDesktop {\n  margin-left: 20px;\n  background-color: #7d3f98;\n  padding: 10px 15px;\n  color: #fff !important;\n  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.3);\n  display: inline-block;\n  border: 0;\n  margin-top: 7px;\n}\n\n.modalEOB {\n  display: none;\n  position: fixed;\n  z-index: 10;\n  padding-top: 300px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal-contentEOB {\n  position: relative;\n  background-color: #fefefe;\n  margin: auto;\n  padding: 0;\n  border: 1px solid #888;\n  width: 40%;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  -webkit-animation-name: g;\n  -webkit-animation-duration: 0.4s;\n  animation-name: g;\n  animation-duration: 0.4s;\n}\n\n.closeEOB {\n  color: #fff;\n  float: right;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.closeEOB:focus,\n.closeEOB:hover {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.modal-headerEOB {\n  padding: 2px 16px;\n  background-color: #7d3f98;\n  color: #fff;\n  height: 40px;\n}\n\n.modal-bodyEOB {\n  padding: 20px;\n  height: 100px;\n}\n\n.modal-footerEOB {\n  padding-top: 23px;\n  text-align: center;\n  background-color: #fff;\n  color: #fff;\n}\n\n.buttonEOBOK {\n  background-color: #7d3f98;\n  border: none;\n  color: #fff !important;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 80px 200px 15px;\n  cursor: pointer;\n}\n\n.modalEOBAndroid {\n  display: none;\n  position: fixed;\n  z-index: 1;\n  padding-top: 125px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal-contentEOBAndroid {\n  position: relative;\n  background-color: #fefefe;\n  margin: auto;\n  padding: 0;\n  border: 1px solid #888;\n  width: 85%;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  -webkit-animation-name: g;\n  -webkit-animation-duration: 0.4s;\n  animation-name: g;\n  animation-duration: 0.4s;\n}\n\n@keyframes g {\n  0% {\n    top: -300px;\n    opacity: 0;\n  }\n\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n.closeEOBAndroid {\n  color: #fff;\n  float: right;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.closeEOBAndroid:focus,\n.closeEOBAndroid:hover {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.modal-headerEOBAndroid {\n  padding: 2px 16px;\n  background-color: #076f86;\n  color: #fff;\n  height: 40px;\n}\n\n.modal-bodyEOBAndroid {\n  padding: 20px;\n  height: 100px;\n}\n\n.modal-footerEOBAndroid {\n  padding: 2px 16px;\n  background-color: #fff;\n  color: #fff;\n  height: 150px;\n}\n\n.buttonEOBOKAndroid {\n  background-color: #076f86;\n  border: none;\n  color: #fff !important;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 25%;\n  cursor: pointer;\n}\n\n@media (max-width: 992px) {\n  .menuTopChrome,\n  .originalTopChromeLinks {\n    display: none;\n  }\n}\n\n@media (min-width: 992px) {\n  .menuTopChrome {\n    padding-right: 25px;\n    padding-left: 25px;\n    display: inline-block;\n    border-right: 2px solid grey;\n    margin-bottom: 15px;\n  }\n\n  .menuLinkTopChrome {\n    color: #7d3f98 !important;\n  }\n\n  .home-util {\n    display: none !important;\n  }\n\n  .originalTopChromeLinks {\n    margin: 0;\n    background-color: #7d3f98 !important;\n    margin-top: -6px;\n    margin-bottom: -6px;\n  }\n\n  .logoutButton {\n    float: right !important;\n    padding: 14px !important;\n    margin-right: 30px !important;\n  }\n\n  .logoutButton,\n  .logoutButton:focus,\n  .logoutButton:hover {\n    color: #fff !important;\n  }\n\n  .bottom_chrome_link {\n    background: #7d3f98;\n    text-align: center;\n    display: inline-block;\n  }\n\n  .navbar-nav {\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .topChromeLogo {\n    width: 100% !important;\n    padding-left: 0;\n    padding-right: 0;\n    text-align: center;\n    display: inline-block;\n  }\n\n  .divMenuTopChrome {\n    width: 100%;\n    font-size: 16px;\n  }\n\n  #adjustPSLogo,\n  .divMenuTopChrome {\n    display: inline-block;\n    text-align: center;\n  }\n\n  #adjustPSLogo {\n    width: 100% !important;\n  }\n\n  .top_chrome_link {\n    margin-right: 30%;\n    padding-top: 20px;\n    color: #7d3f98 !important;\n  }\n\n  .top_welcome_link {\n    font-size: 17px;\n  }\n\n  .top_welcome_link:after {\n    content: \"\\a\";\n    white-space: pre;\n  }\n\n  #aet-content-hdrtxtone,\n  .visiblityHide {\n    visibility: hidden;\n  }\n\n  .navbar-default .navbar-nav > li:first-child > a {\n    margin-top: -80px;\n  }\n\n  .badge {\n    margin-top: 0 !important;\n  }\n\n  .line-seperator {\n    display: none;\n  }\n\n  .aet-content-header .aet-cont-hdrtxt {\n    margin-left: 50% !important;\n  }\n\n  .aet-content-header .aet-cont-hdrtxt,\n  .aet-content-header .aet-cont-hdrtxtNew {\n    font-size: 32px !important;\n    width: 100% !important;\n    text-align: center;\n    font-family: Domaine display !important;\n  }\n\n  .aet-content-header .aet-cont-hdrtxtNew {\n    color: #fff;\n    padding: 10px 0;\n    font-family: domaine display !important;\n  }\n\n  .navbar-nav > li > a {\n    color: #fff !important;\n  }\n\n  .nav > li > a:focus,\n  .nav > li > a:hover {\n    text-decoration: none;\n    background-color: transparent !important;\n  }\n\n  .second-navigation {\n    text-align: left;\n    height: 61px;\n    z-index: 2;\n    background-color: #eee;\n    border-bottom: 2px solid #7d3f98 !important;\n  }\n\n  .collapse.navbar-collapse {\n    margin-right: 0;\n    min-width: 25%;\n  }\n}\n\n@media (max-width: 992px) {\n  .nav-mobile-list {\n    display: inline-flex;\n  }\n\n  .badge {\n    background: #b18cc0;\n  }\n\n  .navigator-logos {\n    margin-left: 35%;\n    margin-top: 1% !important;\n    margin-bottom: -19% !important;\n  }\n\n  .sidenav {\n    height: 100%;\n    width: 0;\n    position: fixed;\n    z-index: 9999999999;\n    top: 0;\n    left: 0;\n    background-color: #7d3f98;\n    overflow-x: hidden;\n    transition: 0.2s;\n    padding-top: 60px;\n  }\n\n  .sidenav .menu-list a,\n  .sidenav .menu-list p {\n    text-decoration: none;\n    font-size: 16px;\n    color: #fff !important;\n    display: block;\n    transition: 0.2s;\n  }\n\n  .sidenav a:hover {\n    color: #f1f1f1;\n  }\n\n  .entireWarpper {\n    transition: margin-left 0.2s;\n  }\n\n  @media screen and (max-height: 450px) {\n    .sidenav {\n      padding-top: 15px;\n    }\n\n    .sidenav a {\n      font-size: 18px;\n    }\n  }\n\n  ul.menu-list li {\n    margin: 0;\n    padding: 0 !important;\n  }\n\n  .home-mobile-list li img,\n  .menu-list li a img.left-img {\n    display: none;\n  }\n\n  .mobile-list-new {\n    margin-left: 36px !important;\n    padding-left: 0 !important;\n  }\n\n  ul.menu-list li.home-mobile-list ul li {\n    padding: 2px 7px !important;\n    border-bottom: 0;\n  }\n\n  .menu-list {\n    background-color: #7d3f98;\n    border-bottom: 0 solid #fff;\n  }\n\n  .menu-list li.inactive {\n    background-color: #602978;\n    padding: 0 !important;\n  }\n\n  ul.menu-list li {\n    background: transparent;\n  }\n\n  ul.menu-list li.home-mobile-list {\n    border-top: 1px solid #602978;\n    padding-top: 10px !important;\n    margin-top: 20px !important;\n  }\n\n  .unbindRedundantClick {\n    display: block;\n    background: #602978;\n  }\n\n  ul.menu-list li a {\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n\n  ul.menu-list li a span {\n    color: #fff;\n  }\n\n  .menu-txt,\n  .mobileClick img {\n    display: none;\n  }\n\n  .close-menu {\n    margin-left: 85% !important;\n    height: 150% !important;\n  }\n\n  .home-mobile-menu {\n    display: none;\n  }\n\n  .menu-button {\n    background: transparent;\n    width: 35px;\n    padding: 2px !important;\n    margin: 1%;\n    margin-top: 1px;\n  }\n\n  .navigator-logos img {\n    width: 84px;\n    margin-left: -5% !important;\n  }\n\n  .homeLinkOnMenu {\n    margin-left: 17%;\n    font-size: 18px !important;\n    padding-bottom: 15px;\n  }\n\n  .PharmacyLinkOnMenu {\n    margin-left: 17%;\n  }\n\n  .rotateMenu {\n    transform: rotate(90deg);\n    transition: 0.1s;\n  }\n\n  .aet-content-header .aet-cont-hdrtxt {\n    margin-left: 10% !important;\n    width: 100%;\n    text-align: center;\n    font-family: domaine display !important;\n  }\n\n  ul.menu-list li.home-mobile-list ul li .badge {\n    background: #fff;\n    color: #7d3f98;\n    margin-top: -1px !important;\n  }\n\n  .home_master_tab_group .nav-tabs,\n  .home_master_tab_group .nav-tabs > li > a {\n    background: #eee !important;\n  }\n\n  section {\n    background-color: #eee !important;\n  }\n\n  .forms-navigation {\n    text-align: center;\n  }\n}\n\n@media (min-width: 992px) {\n  .second-navigation a,\n  .second-navigation p {\n    font-size: 16px !important;\n    margin: 0.5% !important;\n    font-weight: 700 !important;\n  }\n\n  .sidenav {\n    display: none;\n  }\n\n  .forms-navigation {\n    text-align: center;\n  }\n\n  .aet-footer .aet-footer-nav li {\n    float: left;\n    width: 20%;\n    border: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  .aet-footer-logo .noPull a img {\n    margin-top: -60px;\n  }\n\n  .aet-footer .aet-footer-nav {\n    width: 90% !important;\n  }\n\n  .navigator-logos .aet-logo img {\n    visibility: visible;\n  }\n\n  .menu-button {\n    display: none !important;\n  }\n\n  ul li a span.font21 {\n    font-size: 21px;\n    font-weight: 400;\n    color: #fff;\n  }\n\n  ul li a span.font-16 {\n    font-size: 18px !important;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n  .topChromeLogout {\n    position: absolute !important;\n    margin-left: 85px !important;\n    width: 100px;\n  }\n\n  .home_group img {\n    margin-top: -20% !important;\n  }\n\n  .noHighlight .left-block > p.marT10 {\n    margin-top: 7%;\n  }\n\n  ul li a span.font-16 {\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .tile_seperator .marT10 li {\n    padding-right: 20px !important;\n  }\n}\n\n@media (max-width: 991px) {\n  ul li a span.font-16 {\n    font-size: 18px !important;\n    margin-left: -25px !important;\n  }\n\n  ul li a span.font21 {\n    font-size: 16px;\n    font-weight: 400;\n    color: #fff;\n  }\n\n  .nav-tabs > li.home_group {\n    padding-left: 0;\n    padding-right: 0;\n    border: 1px solid #ccc;\n    background: #fff !important;\n    box-shadow: 0 0 1.5px 0.5px #ccc;\n    margin-bottom: 10px;\n  }\n\n  .home_master_tab_group .nav-tabs > li > a,\n  .noHighlight {\n    background: #7d3f98 !important;\n  }\n\n  .noHighlight {\n    height: 45px !important;\n  }\n\n  .home_group .tile_seperator {\n    border-top: 0 solid;\n    margin-top: 10%;\n  }\n\n  .noHighlight .left-block .font-16 {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 400;\n  }\n\n  .nav-tabs > li > a {\n    border-radius: 0 0 0 0 !important;\n  }\n\n  .home_group img {\n    margin-top: -35%;\n    width: 40px;\n  }\n\n  .noHighlight .left-block > p.marT10 {\n    margin-top: -2%;\n    margin-left: 20%;\n  }\n\n  #home_tab_accordion {\n    background: transparent !important;\n  }\n\n  .tile_seperator .marT10 li {\n    float: left;\n    width: 50%;\n    padding: 5px 0 7px;\n  }\n\n  .tile_seperator .marT10 li li,\n  .tile_seperator .marT10 li li:last-child {\n    padding: 0;\n  }\n\n  .tile_seperator .marT10 li:last-child {\n    padding-bottom: 15px;\n  }\n\n  .home_master_tab_group .nav-tabs > li > a.pos-rel-block {\n    padding: 13px 0 0 24px !important;\n  }\n\n  .tile_seperator .marT10 li a {\n    color: #7d3798 !important;\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .home_group .buttonpad {\n    padding: 0 !important;\n    display: inline-block;\n    font-size: 16px;\n    margin-bottom: 3%;\n    float: left;\n    margin-left: 10%;\n    background: #fff !important;\n    color: #7d3798 !important;\n    margin-left: 0 !important;\n  }\n\n  .noHighlight .left-block {\n    float: none;\n    width: 100%;\n  }\n\n  .sidenav .left-block {\n    float: left;\n    width: 68%;\n    margin-left: 17%;\n  }\n\n  .aet-footer .aet-footer-nav li {\n    float: left;\n    width: 50%;\n    border-left: 0 none !important;\n  }\n\n  .aet-content-header.canbpink-header,\n  .second-navigation a.canbLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.canbLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n\n  .aet-content-header.blue-header,\n  .second-navigation a.blueLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.blueLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n\n  .aet-content-header.tealgreen-header,\n  .second-navigation a.tealLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.tealLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n\n  .aet-content-header.green-header,\n  .second-navigation a.greenLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.greenLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n}\n\n@media (min-width: 991px) {\n  .inline-home-block a.fontsize24 {\n    color: #7d3f98 !important;\n  }\n\n  .green-patch {\n    background: #b18cc0 !important;\n    color: #000 !important;\n    width: 90%;\n    font-weight: 700;\n    height: 34px;\n    padding: 5px 10px !important;\n  }\n\n  .inline-home-block p.grey-patch {\n    background: #fff !important;\n  }\n\n  .inline-home-block a.fontsize20 {\n    color: #7d3f98 !important;\n    font-size: 16px;\n  }\n\n  .second-navigation a,\n  .second-navigation p {\n    color: #0c0101;\n    background-color: #b18cc0;\n  }\n\n  .col-md-12 .fontsize24 {\n    font-weight: 700;\n    color: #000 !important;\n  }\n\n  .teladoc {\n    border: 1px solid #ccc;\n    box-shadow: 0 0 0;\n    margin: 10px 25px 20px -4px;\n    height: 215px;\n    background-color: #fff;\n    width: 48% !important;\n  }\n\n  .teladoc .left-icon img {\n    width: 35%;\n    margin-top: -13px;\n    margin-left: 13px;\n  }\n\n  .teladocWiththree {\n    border: 1px solid #eee;\n    box-shadow: 0 0 0;\n    margin: 10px 25px 20px -4px;\n    height: 275px;\n    background-color: #fff;\n    width: 31.6% !important;\n  }\n\n  .para-left-border .teladocWiththree .left-icon img,\n  .teladocWiththree .left-icon img {\n    width: 55%;\n    margin-top: -13px;\n    margin-left: 3px;\n  }\n\n  .font24 {\n    font-size: 24px;\n  }\n\n  .col-md-12 .marL25 {\n    text-align: center;\n    margin-right: -4px !important;\n  }\n\n  .col-md-12 .marT25 .bold {\n    display: none !important;\n  }\n\n  .coverage-page-bg {\n    background-color: #eee !important;\n    margin-top: -26px;\n  }\n\n  .home-hdr-value-new a {\n    font-weight: 700 !important;\n    display: block;\n    margin: 5px 0;\n  }\n\n  .home-hdr-value-new .inline-para a,\n  .home-hdr-value-new a,\n  .labelFont {\n    color: #7d3f98 !important;\n  }\n\n  .labelFont {\n    font-size: 24px;\n    margin-left: -10px !important;\n  }\n\n  .hrline {\n    width: 110%;\n    margin-left: -40px;\n    border-top: 2px solid;\n    border-top-color: #b18cc0 !important;\n    font-size: 16px;\n  }\n\n  .paNurseLine {\n    border-bottom: 2px solid;\n    margin-left: 0;\n    border-top: 0 solid;\n    border-bottom-color: #b18cc0 !important;\n    margin-top: 4px;\n  }\n\n  .otherpa {\n    float: none;\n    margin-left: 25px;\n  }\n\n  .inline-para {\n    font-size: 16px;\n  }\n\n  .aet-content-header.canbpink-header,\n  .second-navigation a.canbLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.canbLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n\n  .aet-content-header.blue-header,\n  .second-navigation a.blueLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.blueLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n\n  .aet-content-header.tealgreen-header,\n  .second-navigation a.tealLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.tealLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n\n  .aet-content-header.green-header,\n  .second-navigation a.greenLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.greenLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n}\n\n@media (max-width: 991px) {\n  .inline-home-block a.fontsize24 {\n    color: #7d3f98 !important;\n  }\n\n  .green-patch {\n    background: #b18cc0 !important;\n    color: #000 !important;\n    width: 90%;\n    font-weight: 700;\n    height: 34px;\n    padding: 5px 10px !important;\n  }\n\n  .inline-home-block p.grey-patch {\n    background: #fff !important;\n  }\n\n  .inline-home-block a.fontsize20 {\n    color: #7d3f98 !important;\n    font-size: 14px;\n  }\n\n  .second-navigation a.canbLevel {\n    background-color: #7d3f98;\n  }\n\n  .second-navigation a.canbLevel:after {\n    border-top: 10px solid #7d3f98;\n  }\n\n  .second-navigation a,\n  .second-navigation p {\n    color: #0c0101;\n    background-color: #b18cc0;\n  }\n\n  .col-md-12 .fontsize24 {\n    font-weight: 700;\n    color: #000 !important;\n  }\n\n  .teladoc {\n    border: 1px solid #ccc;\n  }\n\n  .teladoc,\n  .teladocWiththree {\n    box-shadow: 0 0 0;\n    margin: 10px 0 20px;\n    height: 320px;\n    background-color: #fff;\n    width: 100% !important;\n  }\n\n  .teladocWiththree {\n    border: 1px solid #eee;\n  }\n\n  .teladoc .left-icon img,\n  .teladocWiththree .left-icon img {\n    width: 70%;\n    margin-top: -13px;\n    margin-left: 2px;\n  }\n\n  .col-md-12 .marL25 {\n    text-align: center;\n    margin-right: -4px !important;\n  }\n\n  .col-md-12 .marT25 .bold {\n    display: none !important;\n  }\n\n  .coverage-page-bg {\n    background-color: #eee !important;\n    margin-top: -26px;\n  }\n\n  .home-hdr-value-new a {\n    color: #000 !important;\n    font-weight: 700 !important;\n    display: block;\n    margin: 5px 0;\n    font-size: medium;\n    margin-bottom: 4% !important;\n  }\n\n  .home-hdr-value-new .inline-para a {\n    color: #7d3f98 !important;\n  }\n\n  .hrline {\n    width: 107%;\n    margin-left: -13%;\n    border-top: 2px solid;\n    border-top-color: #b18cc0 !important;\n    font-size: 15px;\n  }\n\n  .paNurseLine {\n    border-bottom: 2px solid;\n    margin-left: -3%;\n    margin-bottom: 2% !important;\n    border-top: 0 solid;\n    padding-bottom: 10px !important;\n    border-bottom-color: #b18cc0 !important;\n    font-size: 16px !important;\n  }\n\n  .otherpa {\n    float: none;\n    margin-left: 25px;\n    margin-top: 10px;\n  }\n\n  .home-blocks .bg-white.col-md-4 {\n    width: 108% !important;\n    margin-left: 0 !important;\n  }\n\n  .entireWarpper {\n    background-color: #eee;\n  }\n\n  .coverage-page-bg .aet-template .home-blocks {\n    margin-left: -15px;\n  }\n\n  .inline-para {\n    font-size: 16px;\n    width: 108% !important;\n  }\n}\n\n@media only screen and (min-width: 500px) and (max-width: 991px) {\n  .teladoc .left-icon img {\n    width: 23%;\n    margin-top: -10px;\n    margin-left: 17px;\n  }\n\n  .teladocWiththree .left-icon img {\n    width: 28%;\n    margin-top: -10px;\n    margin-left: 17px;\n  }\n\n  .teladoc {\n    height: 240px;\n  }\n\n  .teladocWiththree {\n    height: 320px;\n  }\n\n  .paNurseLine {\n    margin-left: 0;\n    margin-top: 15px !important;\n  }\n\n  .hrline {\n    margin-top: -8px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1150px) {\n  .teladoc .left-icon img {\n    width: 23%;\n    margin-top: -10px;\n    margin-left: 17px;\n  }\n\n  .teladocWiththree {\n    border: 1px solid #eee;\n    box-shadow: 0 0 0;\n    margin: 8x 25px 20px -4px;\n    height: 285px;\n    background-color: #fff;\n    width: 31% !important;\n  }\n\n  .teladocWiththree .fontsize24 {\n    font-weight: 700;\n    color: #000 !important;\n    font-size: 16px;\n  }\n\n  .hrline {\n    width: 100%;\n    font-size: 16px;\n  }\n\n  .otherpa {\n    float: none;\n    margin-left: 20px;\n  }\n\n  .home-hdr-value-new .left-icon {\n    margin-top: 14px;\n    padding-left: 10px !important;\n  }\n\n  .teladocWiththree .left-icon img {\n    width: 42%;\n    margin-top: -10px;\n    margin-left: 15px;\n  }\n\n  .teladoc {\n    height: 240px;\n  }\n\n  .teladocWiththree {\n    height: 320px;\n  }\n\n  .paNurseLine {\n    margin-left: 0;\n    margin-top: 15px !important;\n  }\n\n  .hrline {\n    margin-top: -8px;\n  }\n}\n\n#payflexTab {\n  background: #7d3f98;\n}\n\n@media (min-width: 991px) {\n  .topChromeLogout {\n    position: absolute !important;\n    margin-left: 200px;\n    width: 100px;\n  }\n\n  .benefits_Overview .pha-hdr-txt {\n    color: purple !important;\n    margin-left: -12px !important;\n  }\n\n  .benefits_Overview .pha-hdr-txt.black-text,\n  .infogramHead a {\n    color: #7d3f98 !important;\n  }\n\n  .home-blocks {\n    box-shadow: 0 0 0;\n    margin: 2px 0 17px 2px;\n    background-color: #eee;\n    width: 100% !important;\n  }\n\n  .benefits_Overview .mrgnT20 {\n    background-color: #f8f8f8 !important;\n  }\n\n  .home-blocks .bg-white .services-list {\n    background: #fff !important;\n    border: 1px solid #ffff !important;\n  }\n\n  .border-top-purple {\n    border-top: 2px solid #7d3f98 !important;\n    margin-top: -11px;\n  }\n\n  .printOverviewDisplay a img {\n    width: 8%;\n  }\n\n  #My_Coverage {\n    margin-top: 39px;\n    height: 1080px;\n  }\n\n  #select-member-name {\n    height: 33px;\n  }\n\n  .Cov1 {\n    width: 102%;\n    margin-left: -4px;\n  }\n\n  .Cov3 {\n    width: 100%;\n    margin-left: -19px;\n  }\n\n  .infogramHead a {\n    font-weight: 400 !important;\n  }\n\n  .rem {\n    margin-left: -312px;\n  }\n\n  .rem,\n  .remDen {\n    background-color: transparent;\n    box-shadow: 0 0 0 0 #9e9e9e;\n    margin-top: 80px;\n    margin-bottom: 12px;\n  }\n\n  .remDen {\n    margin-left: -290px;\n  }\n\n  .remAhf {\n    background-color: transparent;\n    box-shadow: 0 0 0 0 #9e9e9e;\n    margin-top: 90px;\n    margin-left: -305px;\n    margin-bottom: 12px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .benefits_Overview .pha-hdr-txt {\n    color: purple !important;\n    margin-left: -12px !important;\n    font-size: 22px;\n  }\n\n  .benefits_Overview .pha-hdr-txt.black-text,\n  .infogramHead a {\n    color: purple !important;\n  }\n\n  .home-blocks {\n    box-shadow: 0 0 0;\n    margin: 2px 0 17px 2px;\n    background-color: #eee;\n    width: 100% !important;\n  }\n\n  .benefits_Overview .mrgnT20 {\n    background-color: #f8f8f8 !important;\n  }\n\n  .home-blocks .bg-white .services-list {\n    background: #fff !important;\n    border: 1px solid #ffff !important;\n  }\n\n  .border-top-purple {\n    border-top: 2px solid #7d3f98 !important;\n    margin-top: -11px;\n  }\n\n  .printOverviewDisplay a img {\n    width: 8%;\n  }\n\n  #My_Coverage {\n    margin-top: 39px;\n    height: 1050px;\n  }\n\n  #select-member-name {\n    height: 33px;\n  }\n\n  .Cov1 {\n    width: 102%;\n    margin-left: -4px;\n  }\n\n  .Cov3 {\n    width: 108%;\n    margin-left: -19px;\n  }\n\n  .infogramHead a {\n    font-weight: 400 !important;\n  }\n\n  .rem,\n  .remDen {\n    margin-top: 40px;\n  }\n\n  .rem,\n  .remAhf,\n  .remDen {\n    background-color: transparent;\n    box-shadow: 0 0 0 0 #9e9e9e;\n    margin-bottom: 12px;\n  }\n\n  .remAhf {\n    margin-top: 45px;\n  }\n\n  .second-navigation a {\n    border-bottom: 0 solid #7d3f98 !important;\n  }\n}\n\n.second-navigation a {\n  border-bottom: 1px solid #7d3f98 !important;\n}\n\n#carouselButtons {\n  margin-left: 47%;\n  position: absolute;\n  bottom: 50px;\n  z-index: 15;\n}\n\n#homeCarousel {\n  height: 360px;\n}\n\n.carousel-indicators .active {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  background-color: #7d3f98;\n}\n\n.carousel-indicators li {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin: 1px;\n  text-indent: -999px;\n  cursor: pointer;\n  /* background-color: #000\\9;*/\n  background-color: #b18cc0;\n  border: 0 solid #7d3f98;\n  border-radius: 10px;\n}\n\n.carousel-indicators {\n  position: absolute;\n  bottom: -5px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n}\n\n#pauseButton,\n#playButton {\n  color: #7d3f98;\n  cursor: pointer;\n  position: absolute;\n}\n\n.psImageWidth {\n  font-size: 15px;\n  color: #7d3f98;\n}\n\n.inline-para[nvstyle=\"planSponserBannerParagraph2\"] {\n  color: #414141;\n}\n\n.alignPara {\n  display: inline-block;\n  margin-right: 2%;\n  color: #7d3f98;\n}\n\n.sponsor-block img {\n  margin: 0 !important;\n  padding: 0;\n  vertical-align: initial;\n}\n\n.sponsor_details {\n  box-shadow: 0 0 1.5px 0.5px grey;\n}\n\n@media screen and (max-width: 991px) {\n  #homeCarousel {\n    height: 415px;\n  }\n\n  #carouselButtons {\n    margin-left: 40%;\n    position: absolute;\n    bottom: 50px;\n    z-index: 9999;\n  }\n\n  .carousel-indicators {\n    bottom: -12px;\n    width: 54%;\n  }\n}\n\n.white-bg-mail-address {\n  background: #eee !important;\n  margin: 20px 0;\n}\n\n.align-lang-assist {\n  padding-right: 53px;\n}\n\n.footer-langAssistant {\n  margin-top: 75px;\n  font-size: 14px;\n}\n\n.footer-langAssistant > a,\n.footer-langAssistant > a > span {\n  color: #7d3f98;\n  font-weight: 700;\n  font-size: 16px;\n  padding-left: 0 !important;\n  float: none !important;\n}\n\n#alignLangAssistantLink {\n  text-align: left;\n}\n\n@media (max-width: 767px) {\n  .aet-footer-logo {\n    padding: 10px 0;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  .topChromeLogout {\n    position: absolute !important;\n    margin-left: 85px !important;\n    width: 100px;\n  }\n\n  .navbar-default .navbar-nav > li:first-child > a {\n    margin-top: -60px;\n  }\n\n  .home_group .tile_seperator {\n    border-top: 0 solid;\n    margin-top: 3%;\n  }\n\n  .home_group img {\n    margin-top: -10% !important;\n    padding-right: 10px;\n  }\n\n  .noHighlight .left-block > p.marT10 {\n    margin-top: -1%;\n  }\n\n  .home_master_tab_group .nav-tabs > li > a.pos-rel-block {\n    margin-top: -10px;\n    float: left;\n  }\n\n  a[nvstyle=\"green\"] img {\n    margin-top: -5px !important;\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {\n  .noHighlight .left-block > p.marT10 {\n    margin-top: 7%;\n    margin-left: 20%;\n  }\n\n  .navbar-default .navbar-nav > li:first-child > a {\n    margin-top: -60px;\n  }\n\n  ul li a span.font-16 {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n  }\n\n  .alignPara,\n  .inline-para {\n    font-size: 14px;\n  }\n\n  a[nvstyle=\"marqueeLinkReadMore\"] {\n    padding-left: 26%;\n    padding-right: 26%;\n  }\n\n  .teladoc {\n    height: 235px;\n  }\n}\n\n@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (orientation: landscape) {\n  .home_group img {\n    margin-top: -16%;\n    width: 25px;\n  }\n\n  .home_group .tile_seperator {\n    margin-top: 5%;\n  }\n\n  .noHighlight .left-block > p.marT10 {\n    margin-top: -1%;\n    margin-left: 10%;\n  }\n}\n\n@media (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .navbar-default .navbar-nav > li:first-child > a {\n    margin-top: -57px !important;\n  }\n}\n\n@media (max-width: 991px) {\n  .border-top-color-Sponsor-Links {\n    border-top: none !important;\n    text-align: center;\n  }\n\n  .sponsor-block h2 {\n    font-weight: 700 !important;\n  }\n}\n\n@media (min-width: 992px) {\n  #eobPages {\n    font-size: 0 !important;\n  }\n\n  .topChromeLogoutAlign {\n    position: absolute !important;\n    margin-left: 100px;\n    width: 100px;\n  }\n\n  .center-btn {\n    display: block;\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n\n#myVideoBtn {\n  top: 20px;\n  background-color: #7d3f98;\n}\n\n.sideVideoLink {\n  color: #fff;\n  font-size: 28px;\n  top: 8px;\n}\n\n.sundayAPV {\n  text-align: center !important;\n}\n\n.title {\n  font-size: 16px;\n  color: #414141;\n  font-weight: 700;\n}\n\n.center-align {\n  text-align: center;\n}\n\n.ahText-Color {\n  color: #7d3798;\n}\n\n.showEmailLeft,\n.showFaxLeft {\n  line-height: normal !important;\n}\n\n#displaySharePopup {\n  overflow: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
